import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { format, addDays } from 'date-fns';
import { CSVLink } from 'react-csv';
import DateRanger from '../../components-react/DateRanger';
import { Button, Form } from 'react-bootstrap';
import '../../../styles/docs/toggle-switch.css';
import DotLoaders from '../../common-components/loaders/DotLoaders';
import { currentMonthCurrentDate, currentMonthTomorrowDate } from '../../common-data/Converts';
import {
  active_deleted,
  activeInactiveStatus,
  added_not_added_to_lead_boolean,
  all_access_plan,
  all_account_types,
  approval_require,
  approve_reject_pending,
  bca_scheduler_condition,
  bca_status,
  bca_status_tme,
  biomaxAppRegisterStatus,
  broadcast_channel,
  broadcast_logs_status,
  broadcast_variable,
  couple_plan_filter,
  days_upto_30,
  daysAfterUptoYear,
  daysAgo,
  df_payment_modes,
  dfPaymentStatus,
  discount_payments_approval_status,
  email_statuses,
  expense_statuses,
  experience_level,
  gender,
  halfday_late_checkin_statuses,
  hours_upto_24,
  hygieneAsignee,
  hygieneMeadiaTypes,
  hygine_task_frequency_categories,
  inventory_claim_status,
  lead_stage,
  leadClosingOPeningStatuses,
  leadCustomerCategories,
  leadFollowupStages,
  leadFrom,
  leadPlanTypes,
  leaveStatus,
  memberGoals,
  mins_upto_60,
  months,
  new_existing_member,
  notify_statuses,
  odm_lead_from,
  ODM_STATUS,
  onboarding_staff_types,
  ONBOARDING_STATUS,
  one_day_membership_status,
  payment_location,
  planTypes,
  pt_interest,
  pt_plan_status,
  raw_lead_from,
  recusrring_status,
  referral_statuses,
  regularPlansDropdown,
  resolve_status,
  roaster_status,
  scheduler_types,
  shift_statuses,
  shift_timings,
  shift_types,
  staff_types,
  submission_type,
  subscription_status,
  susbscriptionStatus,
  TASK_APPROVAL_STATUS,
  TASK_PRIORITY,
  template_categories,
  timeSlots,
  timeSlotsQuarter,
  trainer_rating,
  UTMSources,
  variable_types,
  weekoff_status,
  withinDays,
  wp_template_status,
  years,
  three_day_assigned,
  three_day_day_no,
  three_day_completed_count,
  three_day_slot_time,
  resolution_status,
  regularization_approval_status,
  tme_analysis_attendance_checkin_status,
  trainer_receptionist_both,
  required_not_required_statuses,
  wtf_360_consultation_statuses,
  trainer_notification_log_statuses,
  yearsPast100,
  fresh_existing,
  stuck_status,
  three_day_pt_trial_session_status,
  visit_scheduled_options,
  visit_done_options,
  wap_sent_status,
  wap_delivered_status,
  wap_read_status,
} from '../../common-data/DropdowData';
import {
  fetchCustomerIntentData,
  fetchFollowupStatusData,
  fetchRawLeadStatsData,
} from '../../../redux/reducers/apiSlice';
import SelectDropdownLabel from '../../components-react/SelectDropdownLabel';
import { selectGymData } from '../../../redux/reducers/gymDataSlice';
import { fetchGymData } from '../../../data/APIs';
import SelectDropdownDynamic from '../../components-react/SelectDropdownDynamic';
import {
  fetchExpenseAccountantsData,
  fetchExpenseProcessManagersData,
  fetchGymCitiesData,
  fetchInHouseUsersData,
  fetchLeadCaptureKeywordData,
  fetchLeadFromSourceData,
  fetchLeadSourceData,
  fetchOperatorValuesData,
  fetchUTMParamsData,
  fetchWorkoutGoalsData,
} from '../../../redux/reducers/dropdownApiSlice';
import RedButton from '../../common-components/RedButton';
import {
  fetchExpenseCategoriesData,
  fetchHygineTaskCategoryData,
} from '../../../redux/hygiene-reducers/hygieneSlice';
import SelectDropdown from '../../components-react/SelectDropdown';
import MultiSelect from '../../components-react/MultiSelect';
import SingleDatePicker from '../../pt-trials/common/SingleDatePicker';
import { getCardLabel, getCardValue, keyMapping } from '../raw-leads/RawLeadCommon';
import CmnFilterCardBlock from './CmnFilterCardBlock';
import {
  fetchDashboardFeatureGroupingdata,
  fetchDashboardFeaturesdata,
  fetchDashboardMenusdata,
} from '../../../redux/dashboard-features/featuresSlice';
import { fetchBTLVendorsData } from '../../../redux/prospect-reducers/prospectSlice';
import { getIntentColor, intentColorMap, isDev } from '../../common-data/Commons';
import { fetchCentralisedPlanCategoriesData } from '../../../redux/plans-reducers/plansSlice';
import {
  fetchBroadcastTemplatesData,
  fetchBroadcastWPTemplatesData,
} from '../../../redux/ad-blog-reducers/blogSlice';
import CustomFilterTopInfo from '../../common-components/custom-comps/CustomFilterTopInfo';
import {
  ArrowClockwiseIcon,
  BiCheckIcon,
  BiSearchIcon,
  BiXIcon,
  CrossIcon,
  DateRangerIcon,
  DateRangerIcon1,
  DownIcon,
  InfoCircleIcon,
  RedCrossIcon,
  UpIcon,
} from '../../../images/icons/icons';
import { fetchGymLandingPagesData } from '../../../redux/website-reducers/websiteSlice';

const CmnFilters = (props) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);

  const {
    from,
    isSegment,
    userInfoData,
    searchFilterApplied,
    filters,
    setFilters,
    onClickSearch,
    onClickReset,
    isFromLeadManagement,
    onClickExportBtn,
    onClickBroadcastBtn,
    isTop,
    setActiveCardIndex,
    clickedCard,
    isLoading,
    selectedTab,
    infoTxt,
    isReload,
    searchPlaceHolder,
    watiCreds,
    activeTab,
    exportLoading,
    csvData,
    csvFileName,
  } = props || {};

  const token = userInfoData?.token || '';

  const { customerIntentCategory, followupStatuses, rawLeadStats } = useSelector(
    (state) => state.api
  );
  const {
    leadCaptureKeywords,
    leadSources: dynamic_lead_sources,
    gymCities,
    inhouseUsers,
    leadFromSource,
    utmParams,
    operatorValue,
    processManagers,
    expenseAccountants,

    workoutGoals,
  } = useSelector((state) => state.dropdown);
  const { hygineTaskCategory, expenseCategories } = useSelector((state) => state.hygiene);
  const { dashboardMenus, dashboardFeatures, dashFeatureGrouping } = useSelector(
    (state) => state.features
  );
  const { vendorsBTL, vendorsBTLLoading, vendorsBTLError } = useSelector(
    (state) => state.prospects
  );
  const {
    centralisedPlanCategoriesLoading,
    centralisedPlanCategoriesError,
    centralisedPlanCategories,
  } = useSelector((state) => state.plans);
  const {
    broadcastTemplates,
    broadcastTemplatesLoading,
    broadcastTemplatesError,

    broadcastWPTemplates,
    broadcastWPTemplatesLoading,
    broadcastWPTemplatesError,
  } = useSelector((state) => state.blog);
  const { gymLandingPagesLoading, gymLandingPagesError, gymLandingPages } = useSelector(
    (state) => state.webApi
  );

  const iniAllowedFilters = {
    isSearchShow: false,
    isGymShow: false,
    isCardBlockShow: false,
    isDateRangerShow: false,
    isFollowupDateRangerShow: false,
    isDynamicLeadSourceShow: false,
    isUTMLeadSourceShow: false,
    isLeadStatusShow: false,
    isLeadPlanTypesShow: false,
    isLeadTypeShow: false,
    isFollowupStageShow: false,
    isLeadTableDatesShow: false,
    isCustomerIntentsShow: false,
    isFollowupStatusShow: false,
    isAutomationKeywordsShow: false,
    isExportBtnShow: false,
    isTaskIntervalShow: false,
    isHygieneCategoryShow: false,
    isMediaTypeShow: false,
    isAssignToShow: false,
    isAssigneeStatusShow: false,
    isStatusShow: false,
    isClaimAtGymShow: false,
    isGymCityShow: false,
    isFollowupTimesShow: false,
    isRawLeadFilterTypeShow: false,
    isFromRawLeadShow: false,
    isAssignToFDShow: false,
    isConvertedToShow: false,
    isLeadFromShow: false,
    isTrainerShow: false,
    isPtInterestShow: false,
    isTrainerReceptionistShow: false,
    isStaffTypeShow: false,
    isSignleDateShow: false,
    isShiftTypeShow: false,
    isShiftTimeShow: false,
    isAccountTypeShow: false,
    isFDShow: false,
    isShiftStatusShow: false,
    isHalfDayCheckinShow: false,
    isUTMCampaignShow: false,
    isUTMContentShow: false,
    isUTMMediumShow: false,
    isUTMTermShow: false,
    isAssignedLeadDayShow: false,
    isAssignedLeadHourShow: false,
    isAssignedLeadMinuteShow: false,
    isAssignedLeadFollowupDayShow: false,
    isAssignedLeadFollowupHourShow: false,
    isAssignedLeadFollowupMinuteShow: false,
    isOperatorValueShow: false,
    isAddedNotAddedToLeadFilterShow: false,
    // isFilterSectionShow: true,
    isRegularPlanTypesShow: false,
    isApprovalManagerShow: false,
    isAPaidByShow: false,
    isCheckinDaysAgoShow: false,
    isCheckinDaysAgoShow1: false,
    isWorkoutDaysAgoShow: false,
    isFitnessProfileToggleShow: false,
    isPtInterestToggleShow: false,
    isFitnessProfileStatusShow: false,
    isTrainerRatingStatusShow: false,
    isApprovalStatusShow: false,
    isIsApprovedStatusShow: false,
    isMonthFilterShow: false,
    isYearFilterShow: false,
    isDashboardMenuShow: false,
    isDashboardFeatureShow: false,
    isTransferFromShow: false,
    isTransferToShow: false,
    isExpiringInDaysShow: false,
    isBTLVendowShow: false,
    isInfoTxtShow: false,
    isNotificationStatusShow: false,
    isHygieneTaskPriorityShow: false,
    isODMStatusShow: false,
    isReloadBtnShow: false,
    isFeatureGroupsShow: false,
    isCoupleplanFilterShow: false,
    isGenderShow: false,
    isPlanTypesShow: false,
    isPaymentModeShow: false,
    isOnboardingStatusShow: false,
    isExpenseCategoryShow: false,
    isWapImageShow: false,
    isAllAccessPlanShow: false,
    isGymCategoryShow: false,
    isTemplateCategoryShow: false,
    isBroadcastBtnShow: false,
    isEmailTemplateShow: false,
    isWPTemplateShow: false,
    isBroadcastChannelShow: false,
    isExperienceLevelShow: false,
    isPaymentLocationShow: false,
    isWatiCredsShow: false,
    isSubmissionTypeShow: false,
    isTrainerStatusShow: false,
    isRegularPlanStatusShow: false,
    isPTPlanStatusShow: false,
    isBCASchedulerConditionShow: false,
    isScheduleTypeShow: false,
    isStakeholderApprovalStatusShow: false,
    isEmailStatusShow: false,
    isUserApprovalStatusShow: false,
    isBCAStatusShow: false,
    isAssignedStatusShow: false,
    isDayNoShow: false,
    isCompletedCountShow: false,
    isSlotTimeShow: false,
    isCompletedDateRangeShow: false,
    isLeadStageShow: false,
    isRoasterStatusShow: false,
    isWeekoffStatusShow: false,
    isToggleFilterShow: false,
    isLandingPageKeywordShow: false,
    isRenewalShow: false,
    isStuckShow: false,
    isThreeDayTrialShow: false,
    isVisitScheduledShow: false,
    isVisitDoneShow: false,
    isWapSentShow: false,
    isWapDeliveredShow: false,
    isWapReadShow: false,
  };
  const [allowedFilters, setAllowedFilters] = useState(iniAllowedFilters);

  const isAdmin =
    userInfoData?.account_type === 'admin' || userInfoData?.account_type === 'marketing';
  const isReceptionist = userInfoData?.account_type === 'receptionist';
  const isMarketing = userInfoData?.account_type === 'marketing';
  const isTrainer = userInfoData?.account_type === 'trainer';
  const isClusterManager = userInfoData?.account_type === 'cluster_manager';

  const isManagerRole = [
    'cluster_manager',
    'fitness_manager',
    'sales_manager',
    'club_manager',
  ].includes(userInfoData?.account_type);

  const isCreator =
    isDev ||
    userInfoData?.email === 'mousumi.malik@wtfup.me' ||
    userInfoData?.email === 'naresh.kukreti@wtfup.me';

  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: 'selection',
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const [activeDateRanges, setActiveDateRanges] = useState({
    leadAddDate: false,
    leadFollowupDate: false,
    leadLastFollowupDate: false,
    leadClosureDate: false,
    leadConvertedDate: false,
    leadAssignDate: false,
    rawLeadAddDate: false,
    expenseApproveRejectDate: false,
    paidDate: false,
    lastCheckinDate: false,
    lastCheckinDate1: false,
    lastWorkoutDate: false,
    approvalDate: false,
    checkinDate: false,
    expiredDate: false,
    scheduledDate: false,
    threeDayDoneDate: false,
  });
  const createDateRange = (key) => ({
    startDate: null,
    endDate: null,
    key,
  });
  const initialRangeStates = {
    leadAddDate: [createDateRange('leadAddDate')],
  };
  if (from === 'lead-management' || from === 'one-day-membership' || from === 'referrals') {
    if (from === 'lead-management') {
      initialRangeStates.leadFollowupDate = [createDateRange('leadFollowupDate')];
      initialRangeStates.leadLastFollowupDate = [createDateRange('leadLastFollowupDate')];
      initialRangeStates.rawLeadAddDate = [createDateRange('rawLeadAddDate')];
    }

    if (!from === 'one-day-membership' || (from === 'one-day-membership' && selectedTab !== 0)) {
      initialRangeStates.leadConvertedDate = [createDateRange('leadConvertedDate')];
    }
  } else if (from === 'raw-lead' && clickedCard !== 'referral' && clickedCard !== 'wati_leads') {
    initialRangeStates.leadAssignDate = [createDateRange('leadAssignDate')];
  } else if (from === 'expense-management') {
    initialRangeStates.expenseApproveRejectDate = [createDateRange('expenseApproveRejectDate')];
    initialRangeStates.paidDate = [createDateRange('paidDate')];
  } else if (from === 'trainer-member-engagement' || from === 'pt-prospects') {
    if (from === 'pt-prospects') {
      initialRangeStates.leadClosureDate = [createDateRange('leadClosureDate')];
      initialRangeStates.leadConvertedDate = [createDateRange('leadConvertedDate')];
    }

    initialRangeStates.lastCheckinDate = [createDateRange('lastCheckinDate')];
    if (from === 'trainer-member-engagement') {
      initialRangeStates.lastWorkoutDate = [createDateRange('lastWorkoutDate')];
    }
    initialRangeStates.lastCheckinDate1 = [createDateRange('lastCheckinDate1')];
    if (from === 'trainer-member-engagement') {
      if (selectedTab !== 1) {
        initialRangeStates.approvalDate = [createDateRange('approvalDate')];
      }

      initialRangeStates.checkinDate = [createDateRange('checkinDate')];

      if (selectedTab === 3) {
        initialRangeStates.expiredDate = [createDateRange('expiredDate')];
      }
    }
  } else if (from === 'fitness-profile-logs' && clickedCard === 'bca-logs') {
    initialRangeStates.scheduledDate = [createDateRange('scheduledDate')];
  } else if (
    from === 'member-checkin-logs' ||
    from === 'live-bca-logs-notifications' ||
    from === 'live-pt-trial-notifications'
  ) {
    initialRangeStates.threeDayDoneDate = [createDateRange('threeDayDoneDate')];
  }
  const [rangeStates, setRangeStates] = useState(initialRangeStates);
  const [customerIntents, setCustomerIntents] = useState([]);
  const [followupStatus, setFollowupStatus] = useState([]);
  const [hygieneCategoriesDropdown, setHygieneCategoriesDropdown] = useState([]);
  const iniDropdownData = {
    allFilterTypesData: [],
    allBTLVendors: [],
    allFeatureGroups: [],
    allEmailTemplates: [],
    allWPTemplates: [],
    allLandingPages: [],
  };
  const [allDropdownData, setAllDropdownData] = useState(iniDropdownData);
  const [allMenus, setAllMenus] = useState([]);
  const [allFeatures, setAllFeatures] = useState([]);
  const iniValues = {
    limit: 1000,
    page: 1,
    search: '',
  };
  const [fetchValues, setFetchValues] = useState(iniValues);
  const [totalPages, setTotalPages] = useState(1);
  const [showInfoTxt, setShowInfoTxt] = useState(false);
  const [allExpenseCategories, setAllExpenseCategories] = useState([]);
  const [allGymCategories, setAllGymCategories] = useState([]);
  function getDateRangerLable(rangeKey, from) {
    switch (rangeKey) {
      case 'leadAddDate':
        return from === 'gym-transfer' || from === 'membership-transfer'
          ? 'Transfer Date'
          : clickedCard === 'scheduled-broadcast-logs'
            ? 'Broadcast Date'
            : from === 'lead-management'
              ? 'Lead Add Date'
              : from === 'renewal-reminder'
                ? 'Reminder date'
                : from === 'hygiene-taks-tabwise'
                  ? 'Task Date'
                  : 'Date Added';
      case 'leadFollowupDate':
        return 'Followup Date';
      case 'leadLastFollowupDate':
        return 'Last Followup Date';
      case 'leadClosureDate':
        return 'Closure Date';
      case 'leadConvertedDate':
        return from === 'pt-prospects' || from === 'one-day-membership' || from === 'referrals'
          ? 'Convert Date'
          : 'Lead Conversion Date';
      case 'rawLeadAddDate':
        return clickedCard === 'wati_leads' ? 'Lead Add Date' : 'Raw Lead Add Date';
      case 'leadAssignDate':
        return 'Raw Lead Assign Date';
      case 'expenseApproveRejectDate':
        return 'Approve/Reject Date';
      case 'paidDate':
        return 'Paid Date';
      case 'lastCheckinDate':
        return 'Member Last Checkin Date';
      case 'lastCheckinDate1':
        return 'Trainer Last Checkin Date';
      case 'lastWorkoutDate':
        return 'Last Workout Date';
      case 'approvalDate':
        return 'Engagement Approve/Reject Date';
      case 'checkinDate':
        return 'Member Checkin Date';
      case 'expiredDate':
        return 'Membership Expiry Date';
      case 'scheduledDate':
        return 'Scheduled Date';
      case 'threeDayDoneDate':
        return 'PT Trial Done Date';
      default:
        return 'Select Date';
    }
  }

  function getDateRangerLableSingle(from) {
    switch (from) {
      case 'lead-management':
        return 'Lead Add Date';
      case 'one-day-membership':
        return 'Date Added';
      case 'df':
        return 'Date Added';
      case 'metabase-links':
        return 'Select Date Added';
      default:
        return 'Select Date';
    }
  }

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, 'yyyy-MM-dd');
    const formattedEndDate = format(item?.selection?.endDate, 'yyyy-MM-dd');

    setFilters({
      ...filters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setFilters({
      ...filters,
      selectedStartDate: '',
      selectedEndDate: '',
    });
  };

  const handleDateRangeChangeMulti = (item, rangeKey) => {
    const startDate = item[rangeKey].startDate;
    const endDate = item[rangeKey].endDate;

    if (startDate && endDate) {
      setRangeStates({
        ...rangeStates,
        [rangeKey]: [item[rangeKey]],
      });

      const formattedStartDate = format(startDate, 'yyyy-MM-dd');
      const formattedEndDate = format(endDate, 'yyyy-MM-dd');

      setFilters({
        ...filters,
        [`${rangeKey}From`]: formattedStartDate,
        [`${rangeKey}To`]: formattedEndDate,
      });
    }
  };

  const clearDateRangerMulti = (rangeKey) => {
    setRangeStates({
      ...rangeStates,
      [rangeKey]: initialRangeStates[rangeKey],
    });

    setFilters({
      ...filters,
      [`${rangeKey}From`]: '',
      [`${rangeKey}To`]: '',
    });
  };

  function getCustomerIntent(filters) {
    dispatch(
      fetchCustomerIntentData({
        filters: filters,
        token: token,
      })
    );
  }

  function getFollowupStatuses(filters) {
    dispatch(
      fetchFollowupStatusData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getAutomationKeyword(filters) {
    dispatch(
      fetchLeadCaptureKeywordData({
        filters: {
          ...filters,
          auto_gym_map: clickedCard === 'wati_leads' ? 1 : '',
        },
        token: userInfoData?.token,
      })
    );
  }

  function getHygieneTaskCategories() {
    const filters = {
      page: 1,
      limit: 1000,
    };

    dispatch(
      fetchHygineTaskCategoryData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getLeadSources(fetchValues) {
    dispatch(
      fetchLeadSourceData({
        filters: fetchValues,
        token: userInfoData?.token,
      })
    );
  }

  function getLeadFromSource(filters = {}) {
    dispatch(
      fetchLeadFromSourceData({
        filters: (filters = {}),
        token: userInfoData?.token,
      })
    );
  }

  function getLandingPages() {
    const sendableFilters = {
      status: 'active',
      page: 1,
      limit: 1000,
    };

    dispatch(
      fetchGymLandingPagesData({
        filters: sendableFilters,
        token: userInfoData?.token,
      })
    );
  }

  function getGymCities() {
    const gymCitiesFilters = {
      status: 'active',
    };

    dispatch(
      fetchGymCitiesData({
        filters: gymCitiesFilters,
        token: userInfoData?.token,
      })
    );
  }

  function getRawLeadStats() {
    const filters = { is_rawlead: 1 };

    dispatch(
      fetchRawLeadStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getUTMParameters(filters = {}) {
    dispatch(
      fetchUTMParamsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getOperatorValue(filters = {}) {
    dispatch(
      fetchOperatorValuesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getExpenseProcessManagers() {
    const filters = {
      page: 1,
      limit: 1000,
      status: 'active',
      role_type: 'approval_manager',
    };

    dispatch(
      fetchExpenseProcessManagersData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getExpenseAccountants() {
    const filters = {
      page: 1,
      limit: 1000,
      status: 'active',
    };

    dispatch(
      fetchExpenseAccountantsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getDashboardMenus() {
    const filters = {
      page: 1,
      limit: 1000,
      status: 1,
    };

    dispatch(
      fetchDashboardMenusdata({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getDashboardFeatures() {
    const allfilters = {
      page: 1,
      limit: 1000,
      status: 1,
      menu_id: filters.selectedMenu?.value || '',
    };

    dispatch(
      fetchDashboardFeaturesdata({
        filters: allfilters,
        token: userInfoData?.token,
      })
    );
  }

  function getBTLVendors() {
    const filters = {
      page: 1,
      limit: 1000,
      status: 'active',
    };

    dispatch(
      fetchBTLVendorsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getDashboardFeatureGrouping() {
    const filters = {
      page: 1,
      limit: 1000,
      status: 'active',
    };

    dispatch(
      fetchDashboardFeatureGroupingdata({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getExpenseCategories() {
    const filters = {
      page: 1,
      limit: 1000,
      status: 'active',
    };

    dispatch(
      fetchExpenseCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const getPlansCategoriesData = (filters) => {
    dispatch(
      fetchCentralisedPlanCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const getWPTemplates = (filters) => {
    dispatch(
      fetchBroadcastWPTemplatesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const getEmailTemplates = (filters) => {
    dispatch(
      fetchBroadcastTemplatesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  function getWorkoutGoals() {
    const filters = {
      page: 1,
      limit: 2000,
      status: 'active',
    };

    dispatch(
      fetchWorkoutGoalsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  // ********-------------
  const handleSearchChange = (inputValue) => {
    setFetchValues((prev) => ({
      ...prev,
      page: 1,
      search: inputValue,
    }));
  };

  const fetchMoreData = () => {
    if (fetchValues.page + 1 <= totalPages) {
      setFetchValues((prev) => ({
        ...prev,
        page: prev.page + 1,
      }));
    }
  };

  const fetchPreviousData = () => {
    setFetchValues((prev) => ({
      ...prev,
      page: Math.max(prev.page - 1, 1),
    }));
  };
  // ------------------**********

  const hasActiveFilters = () => {
    return Object.keys(filters).some((key) => {
      const value = filters[key];

      if (value === null || value === undefined || value === '') return false;

      if (typeof value === 'object' && value !== null) {
        return value.value !== null && value.value !== undefined && value.value !== '';
      }

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'boolean') {
        return value === true;
      }

      return true;
    });
  };

  useEffect(() => {
    if (from === 'lead-management') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isLeadTableDatesShow: true,
        isDynamicLeadSourceShow: true,
        isUTMLeadSourceShow: true,
        isLeadStatusShow: true,
        isCustomerIntentsShow: true,
        isFollowupStatusShow: true,
        isFollowupStageShow: true,
        isOperatorValueShow: filters?.selFollowupStage?.value ? true : false,
        isSearchShow: onClickSearch ? true : false,
        isLeadPlanTypesShow: true,
        isExportBtnShow: !isMarketing && onClickExportBtn ? true : false,
        isFollowupTimesShow: true,
        isLeadFromShow: true,
        isConvertedToShow: true,
        isBTLVendowShow: filters?.selLeadSource?.value === 'btl_marketting' ? true : false,
        isBroadcastBtnShow: onClickBroadcastBtn ? true : false,
        isReloadBtnShow: isReload ? true : false,
        isOtherUserShow: isAdmin ? true : false,
        isAssignToShow: isAdmin || isManagerRole ? true : false,
        isAssigneeStatusShow: true,
        isLeadStageShow: true,
        isToggleFilterShow: isSegment ? false : true,
      }));
    } else if (from === 'raw-lead' && isTop) {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isAutomationKeywordsShow: true,
      }));
    } else if (from === 'raw-lead' && !isTop) {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: true,
        isLeadTableDatesShow: true,
        isDynamicLeadSourceShow:
          clickedCard !== 'referral' && clickedCard !== 'wati_leads' ? true : false,
        isUTMLeadSourceShow: clickedCard !== 'referral' ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isAutomationKeywordsShow: clickedCard !== 'referral' ? true : false,
        isGymCityShow: clickedCard !== 'referral' && clickedCard !== 'wati_leads' ? true : false,
        isRawLeadFilterTypeShow: !isFromLeadManagement ? true : false,
        isAssignToFDShow: true,
        isConvertedToShow: !isFromLeadManagement ? true : false,
        isUTMCampaignShow:
          !isFromLeadManagement &&
          filters?.selUTMSource &&
          filters?.selUTMSource?.value !== 'organic'
            ? true
            : false,
        isUTMMediumShow:
          !isFromLeadManagement &&
          filters?.selUTMSource &&
          filters?.selUTMSource?.value !== 'organic'
            ? true
            : false,
        isUTMContentShow:
          !isFromLeadManagement &&
          filters?.selUTMSource &&
          filters?.selUTMSource?.value !== 'organic'
            ? true
            : false,
        isUTMTermShow:
          !isFromLeadManagement &&
          filters?.selUTMSource &&
          filters?.selUTMSource?.value !== 'organic'
            ? true
            : false,
        isAssignedLeadDayShow: !isFromLeadManagement ? true : false,
        isAssignedLeadHourShow: !isFromLeadManagement ? true : false,
        isAssignedLeadMinuteShow: !isFromLeadManagement ? true : false,
        isAssignedLeadFollowupDayShow: !isFromLeadManagement ? true : false,
        isAssignedLeadFollowupHourShow: !isFromLeadManagement ? true : false,
        isAssignedLeadFollowupMinuteShow: !isFromLeadManagement ? true : false,
        isExportBtnShow: !isFromLeadManagement && onClickExportBtn ? true : false,
        isAssignToShow: clickedCard === 'referral' && (isAdmin || isClusterManager) ? true : false,
        isAddedNotAddedToLeadFilterShow: clickedCard === 'wati_leads' ? true : false,
      }));
    } else if (from === 'hygiene-taks') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isHygieneCategoryShow: true,
        isHygieneTaskPriorityShow: true,
        isTaskIntervalShow: true,
        isMediaTypeShow: true,
        isAssignToShow: true,
        isStatusShow: true,
      }));
    } else if (from === 'hygiene-taks-tabwise') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isLeadTableDatesShow: true,
        isOtherUserShow: true,
        isSearchShow: onClickSearch ? true : false,
        isHygieneCategoryShow: true,
        isCheckinTimeShow: true,
        isHygieneTaskPriorityShow: true,
        isAssignToShow: true,
        isNotificationStatusShow: true,
        // isSignleDateShow: true,
      }));
    } else if (from === 'trainer-member-engagement') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: selectedTab === 4 ? false : true,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isTrainerShow: selectedTab === 4 ? false : !isTrainer ? true : false,
        isLeadTableDatesShow: selectedTab === 4 ? false : true,
        isCheckinDaysAgoShow: selectedTab === 4 ? false : true,
        isCheckinDaysAgoShow1: selectedTab === 4 ? false : true,
        isWorkoutDaysAgoShow: selectedTab === 4 ? false : true,
        isFitnessProfileStatusShow: selectedTab === 4 ? false : true,
        isPtInterestShow: selectedTab === 1 || selectedTab === 4 ? false : true,
        isTrainerRatingStatusShow: selectedTab === 4 ? false : true,
        isCheckinTimeShow: selectedTab === 4 ? false : true,
        isCheckinTimeShow1: selectedTab === 4 ? false : true,
        isApprovalManagerShow: selectedTab === 1 || selectedTab === 4 ? false : true,
        isExpiringInDaysShow: selectedTab === 4 ? false : true,
        isStatusShow: selectedTab === 4 ? false : true,
        isBCAStatusShow: selectedTab === 4 ? false : true,
        isWorkoutGoalsShow: selectedTab === 4 ? false : true,
        isExportBtnShow: selectedTab !== 4 && onClickExportBtn ? true : false,
      }));
    } else if (from === 'staff-attendance-report') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isTrainerReceptionistShow: true,
        isStaffTypeShow: true,
        isSignleDateShow: true,
        isShiftTypeShow: true,
        isShiftTimeShow: true,
        isShiftStatusShow: clickedCard === 'late-checkins' ? false : true,
        isHalfDayCheckinShow: clickedCard === 'late-checkins' ? true : false,
      }));
    } else if (from === 'lead-agent-report') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isDateRangerShow: true,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isAddedTo: isAdmin || isManagerRole ? true : false,
        isOtherUserShow: isAdmin || isManagerRole ? true : false,
        isAccountTypeShow: isAdmin || isManagerRole ? true : false,
      }));
    } else if (from === 'fd-task-sop') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isDateRangerShow: true,
        isFDShow: isReceptionist ? false : true,
      }));
    } else if (from === 'one-day-membership') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isLeadTableDatesShow: true,
        isGymShow:
          (isAdmin || isManagerRole) && clickedCard !== 'one_day_membership_testing' ? true : false,
        isSearchShow: selectedTab === 0 ? false : onClickSearch ? true : false,
        isStatusShow: selectedTab === 1 ? true : false,
        isAddedNotAddedToLeadFilterShow: true,
        isODMStatusShow: selectedTab === 1 ? true : false,
        isUTMLeadSourceShow: selectedTab !== 0 && clickedCard !== 'walkins' ? true : false,
        isUTMCampaignShow:
          selectedTab !== 0 && filters?.selUTMSource && filters?.selUTMSource?.value !== 'organic'
            ? true
            : false,
        isUTMMediumShow:
          selectedTab !== 0 && filters?.selUTMSource && filters?.selUTMSource?.value !== 'organic'
            ? true
            : false,
        isUTMContentShow:
          selectedTab !== 0 && filters?.selUTMSource && filters?.selUTMSource?.value !== 'organic'
            ? true
            : false,
        isUTMTermShow:
          selectedTab !== 0 && filters?.selUTMSource && filters?.selUTMSource?.value !== 'organic'
            ? true
            : false,
        isExportBtnShow:
          // selectedTab !== 0 &&
          // clickedCard !== "one_day_membership_testing" &&
          // (selectedTab === 1 || selectedTab === 3) &&
          onClickExportBtn ? true : false,
        isGenderShow: selectedTab === 1 ? true : false,
        isAutomationKeywordsShow: selectedTab === 2 ? true : false,
        isLeadStatusShow: selectedTab === 2 ? true : false,
        isBroadcastBtnShow:
          ((selectedTab === 1 && clickedCard === 'one_day_membership') ||
            selectedTab === 2 ||
            selectedTab === 3 ||
            selectedTab === 4) &&
          onClickBroadcastBtn
            ? true
            : false,
        isReloadBtnShow: isReload ? true : false,
        isLeadFromShow: selectedTab === 1 ? true : false,
        isLandingPageKeywordShow: selectedTab === 1 || selectedTab === 2 ? true : false,
        isVisitScheduledShow: selectedTab === 1 || selectedTab === 2 ? true : false,
        isVisitDoneShow: selectedTab === 1 || selectedTab === 2 ? true : false,

        // isAssignedLeadDayShow: true,
        // isAssignedLeadHourShow: true,
        // isAssignedLeadMinuteShow: true,
        // isAssignedLeadFollowupDayShow: true,
        // isAssignedLeadFollowupHourShow: true,
        // isAssignedLeadFollowupMinuteShow: true,
      }));
    } else if (from === 'odm-gymwise') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isLeadTableDatesShow: true,
        isReloadBtnShow: isReload ? true : false,
      }));
    } else if (from === 'pt-prospects') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isSearchShow: onClickSearch ? true : false,
        isLeadTableDatesShow: true,
        isTrainerShow: !isTrainer ? true : false,
        isCheckinDaysAgoShow: true,
        isCheckinDaysAgoShow1: true,
        isCheckinTimeShow: true,
        isCheckinTimeShow1: true,
      }));
    } else if (from === 'df') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isOtherUserShow: isAdmin ? true : false,
        isSearchShow: onClickSearch ? true : false,
        isDateRangerShow: true,
        isStatusShow:
          clickedCard !== 'discount-payments' ||
          (clickedCard === 'discount-payments' && (selectedTab === 1 || selectedTab === 3))
            ? true
            : false,
        isRegularPlanTypesShow:
          clickedCard !== 'discount-payments' ||
          (clickedCard === 'discount-payments' && (selectedTab === 0 || selectedTab === 1))
            ? true
            : false,
        isCoupleplanFilterShow: clickedCard !== 'discount-payments' ? true : false,
        isGenderShow: true,
        isPaymentModeShow: true,
        isIsApprovedStatusShow:
          clickedCard === 'discount-payments' && (selectedTab === 0 || selectedTab === 2)
            ? true
            : false,
        isApprovalManagerShow:
          clickedCard === 'discount-payments' && (selectedTab === 0 || selectedTab === 2)
            ? true
            : false,
        isExperienceLevelShow: true,
        isPaymentLocationShow: true,
        isDynamicLeadSourceShow: true,
        isWapSentShow:
          clickedCard !== 'discount-payments' ||
          (clickedCard === 'discount-payments' && (selectedTab === 1 || selectedTab === 3))
            ? true
            : false,
        isWapDeliveredShow:
          clickedCard !== 'discount-payments' ||
          (clickedCard === 'discount-payments' && (selectedTab === 1 || selectedTab === 3))
            ? true
            : false,
        isWapReadShow:
          clickedCard !== 'discount-payments' ||
          (clickedCard === 'discount-payments' && (selectedTab === 1 || selectedTab === 3))
            ? true
            : false,
      }));
    } else if (from === 'expense-management') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isOtherUserShow: isAdmin || isClusterManager ? true : false,
        isApprovalManagerShow: false,
        isAPaidByShow: true,
        isLeadTableDatesShow: true,
        isStatusShow: clickedCard !== 1 ? true : false,
        isSearchShow: onClickSearch ? true : false,
        isExpenseCategoryShow: true,
      }));
    } else if (from === 'referrals') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isOtherUserShow: isAdmin ? true : false,
        isLeadTableDatesShow: true,
        isStatusShow: true,
        isSearchShow: onClickSearch ? true : false,
        isAccountTypeShow: true,
        isAddedNotAddedToLeadFilterShow: true,
      }));
    } else if (from === 'fitness-center') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isStatusShow: true,
        isGymCityShow: true,
      }));
    } else if (from === 'gym-members') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: selectedTab === 0 ? false : onClickSearch ? true : false,
        isStatusShow: true,
        isTrainerShow: selectedTab === 1 && !isTrainer ? true : false,
      }));
    } else if (from === 'agent-daily-target') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isFDShow: isAdmin ? true : false,
        isMonthFilterShow: true,
        isYearFilterShow: true,
        isOtherUserShow: isAdmin ? true : false,
      }));
    } else if (from === 'agent-weekly-target') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isMonthFilterShow: true,
        isYearFilterShow: true,
      }));
    } else if (from === 'import-members') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isApprovalManagerShow: selectedTab !== 0 && selectedTab !== 1 ? true : false,
        isOtherUserShow: (isAdmin || isManagerRole) && selectedTab !== 0 ? true : false,
      }));
    } else if (from === 'feature-mappings') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isAccountTypeShow: true,
        isOtherUserShow: isAdmin ? true : false,
        isFeatureGroupsShow: true,
      }));
    } else if (from === 'assigned-feature') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isDashboardMenuShow: true,
        isDashboardFeatureShow: true,
      }));
    } else if (from === 'pt-transfer') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isTrainerShow: true,
        isStatusShow: true,
        isTransferFromShow: true,
      }));
    } else if (from === 'pt-transfer-history') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isTransferFromShow: true,
        isTrainerShow: true,
        isOtherUserShow: true,
      }));
    } else if (from === 'btl-leads') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isBTLVendowShow: true,
        isAddedNotAddedToLeadFilterShow: true,
        isLeadTableDatesShow: true,
      }));
    } else if (from === 'sales-value') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSignleDateShow: true,
        isGymCityShow: true,
        isInfoTxtShow: true,
        isOtherUserShow: isAdmin ? true : false,
        isReloadBtnShow: isReload ? true : false,
      }));
    } else if (from === 'academy-leads') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isLeadTableDatesShow: true,
      }));
    } else if (from === 'um') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isOtherUserShow: isAdmin ? true : false,
        isStatusShow: true,
      }));
    } else if (from === 'docs') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: true,
        isOtherUserShow: isAdmin ? true : false,
        isStatusShow: isCreator ? true : false,
        isAccountTypeShow: isAdmin ? true : false,
        isDashboardFeatureShow: true,
        isNotificationStatusShow: isAdmin ? true : false,
      }));
    } else if (from === 'feedbacks') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isAccountTypeShow: isAdmin ? true : false,
      }));
    } else if (from === 'hygine-submitted-tasks') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isSignleDateShow: true,
        isStatusShow: true,
      }));
    } else if (from === 'hygine-tasks-approval') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isSignleDateShow: true,
        isHygieneCategoryShow: true,
        isHygieneTaskPriorityShow: true,
        isAssignToShow: isAdmin ? true : false,
        isStatusShow: true,
        isSearchShow: onClickSearch ? true : false,
      }));
    } else if (from === 'staff-onboarding') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isStatusShow: true,
        isAccountTypeShow: isAdmin ? true : false,
        isReloadBtnShow: isReload ? true : false,
        isLeadTableDatesShow: true,
        isOnboardingStatusShow: true,
        isFitnessProfileStatusShow: true,
      }));
    } else if (from === 'receptionists') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isStatusShow: true,
      }));
    } else if (from === 'training') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isAssignToShow: true,
        isStatusShow: true,
      }));
    } else if (from === 'couple-membership-request') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isSearchShow: onClickSearch ? true : false,
        isLeadTableDatesShow: true,
        isApprovalStatusShow: true,
        isFitnessProfileStatusShow: true,
      }));
    } else if (from === 'recurring-999') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isLeadTableDatesShow: true,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isSearchShow: onClickSearch ? true : false,
        isAddedNotAddedToLeadFilterShow: true,
        isODMStatusShow: true,
        isUTMLeadSourceShow: true,
        isUTMCampaignShow:
          filters?.selUTMSource && filters?.selUTMSource?.value !== 'organic' ? true : false,
        isUTMMediumShow:
          filters?.selUTMSource && filters?.selUTMSource?.value !== 'organic' ? true : false,
        isUTMContentShow:
          filters?.selUTMSource && filters?.selUTMSource?.value !== 'organic' ? true : false,
        isUTMTermShow:
          filters?.selUTMSource && filters?.selUTMSource?.value !== 'organic' ? true : false,
        isReloadBtnShow: isReload ? true : false,

        isGenderShow: false,
        isAutomationKeywordsShow: false,
        isLeadStatusShow: false,
        isStatusShow: false,
        isLeadFromShow: true,
        isLandingPageKeywordShow: true,

        // isAssignedLeadDayShow: true,
        // isAssignedLeadHourShow: true,
        // isAssignedLeadMinuteShow: true,
        // isAssignedLeadFollowupDayShow: true,
        // isAssignedLeadFollowupHourShow: true,
        // isAssignedLeadFollowupMinuteShow: true,
      }));
    } else if (from === 'gym-feedbacks') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isSearchShow: onClickSearch ? true : false,
        isLeadTableDatesShow: true,
        isApprovalStatusShow: true,
      }));
    } else if (from === 'metabase-links') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isDateRangerShow: true,
        isStatusShow: true,
      }));
    } else if (from === 'dynamic-linking') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
      }));
    } else if (from === 'gym-automation-keyword') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
      }));
    } else if (from === 'cash-reports') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isLeadTableDatesShow: true,
        isSearchShow: onClickSearch ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isOtherUserShow: isAdmin ? true : false,
      }));
    } else if (from === 'gym-landing-pages') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
      }));
    } else if (from === 'plans-categories') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
      }));
    } else if (from === 'gym-alias') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
      }));
    } else if (from === 'centralised-plans') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isPlanDurationShow: true,
        isCoupleplanFilterShow: true,
        isAllAccessPlanShow: true,
        isGymCategoryShow: true,
      }));
    } else if (from === 'gym-transfer' || from === 'membership-transfer') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        // isTransferFromShow: true,
        // isTransferToShow: true,
        isLeadTableDatesShow: true,
        isOtherUserShow: isAdmin || isClusterManager ? true : false,
        isApprovalStatusShow: true,
      }));
    } else if (from === 'pause-system') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isStatusShow: true,
        isPlanDurationShow: true,
      }));
    } else if (from === 'membership-pause') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isStatusShow: true,
        isPlanDurationShow: true,
        isGymShow: true,
        isOtherUserShow: true,
        isSearchShow: onClickSearch ? true : false,
        isLeadTableDatesShow: true,
      }));
    } else if (from === 'inventories') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isStatusShow: true,
        isClaimAtGymShow: true,
        isSearchShow: onClickSearch ? true : false,
      }));
    } else if (from === 'broadcast-templates') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isStatusShow: true,
        isTemplateCategoryShow: true,
        isSearchShow: onClickSearch ? true : false,
      }));
    } else if (from === 'broadcast-wp-templates') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isTemplateCategoryShow: true,
        isStatusShow: true,
        isSearchShow: onClickSearch ? true : false,
        isWatiCredsShow: true,
      }));
    } else if (from === 'broadcast-variables') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isVariableTypeShow: true,
        isVariableValueShow: true,
        isStatusShow: true,
        isSearchShow: onClickSearch ? true : false,
      }));
    } else if (from === 'broadcasts') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
      }));
    } else if (from === 'broadcasts-logs-listings') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isBroadcastChannelShow: true,
        isStatusShow: true,
      }));
    } else if (from === 'walkins-leads') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isLeadTableDatesShow: true,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isSearchShow: onClickSearch ? true : false,
        isAssignToShow: isAdmin ? true : false,
        isAddedNotAddedToLeadFilterShow: true,
        isSubmissionTypeShow: true,
        isGenderShow: true,
        isBroadcastBtnShow: onClickBroadcastBtn ? true : false,
        isReloadBtnShow: isReload ? true : false,
      }));
    } else if (from === 'bca-report') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isTrainerShow: true,
        isStatusShow: true,
        isTrainerStatusShow: true,
      }));
    } else if (from === 'fitness-profile-logs') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isRegularPlanStatusShow: true,
        isPTPlanStatusShow: true,
        isLeadTableDatesShow: true,
        isTrainerShow: true,
        isStatusShow: true,
      }));
    } else if (from === 'health-tracking') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isFitnessProfileStatusShow: true,
        isBCAStatusShow: true,
        isMonthFilterShow: true,
        isYearFilterShow: true,
        isExportBtnShow: onClickExportBtn ? true : false,
      }));
    } else if (from === 'bca-scheduler') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isStatusShow: true,
        isBCASchedulerConditionShow: true,
        isLeadTableDatesShow: clickedCard === 'scheduled-broadcast-logs' ? true : false,
        isScheduleTypeShow: true,
      }));
    } else if (from === 'payrole-processor-logs') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: isAdmin && onClickSearch ? true : false,
        isGymShow: isAdmin ? true : false,
        isAccountTypeShow: isAdmin ? true : false,
        isMonthFilterShow: true,
        isLeadTableDatesShow:
          clickedCard === 'inhouse-users' || clickedCard === 'export-payroll' ? false : true,
        isUserApprovalStatusShow:
          clickedCard === 'inhouse-users' ||
          clickedCard === 'discrepancies' ||
          clickedCard === 'export-payroll' ||
          clickedCard === 'draft-payroll'
            ? false
            : true,
        isStakeholderApprovalStatusShow:
          clickedCard === 'inhouse-users' ||
          clickedCard === 'discrepancies' ||
          clickedCard === 'export-payroll' ||
          clickedCard === 'draft-payroll'
            ? false
            : true,
        isEmailStatusShow: clickedCard === 'draft-payroll' ? true : false,
      }));
    } else if (from === 'payrole-gym-overview') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin ? true : false,
        isMonthFilterShow: true,
      }));
    } else if (from === 'fresh-lead') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isSearchShow: onClickSearch ? true : false,
        isAddedNotAddedToLeadFilterShow: true,
        isLeadStatusShow: true,
        isBroadcastBtnShow: onClickBroadcastBtn ? true : false,
        isReloadBtnShow: isReload ? true : false,
        isAssignToShow: true,
      }));
    } else if (from === 'three-day-trial') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isTrainerShow: true,
        isBCAStatusShow: true,
        isAssignedStatusShow: true,
        isDayNoShow: true,
        isCompletedCountShow: true,
        isSlotTimeShow: true,
        isSearchShow: onClickSearch ? true : false,
      }));
    } else if (from === 'roaster-system') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isTrainerReceptionistShow: selectedTab === 0 && isAdmin ? true : false,
        isMonthFilterShow: selectedTab === 0 ? true : false,
        isSignleDateShow: selectedTab === 0 ? true : false,
        isSearchShow: onClickSearch ? true : false,
        isReloadBtnShow: isReload ? true : false,
        isRoasterStatusShow: selectedTab === 1 || selectedTab === 2 ? true : false,
        isWeekoffStatusShow: selectedTab === 0 ? true : false,
      }));
    } else if (from === 'staff-profiles') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isLeadTableDatesShow: true,
        isStaffTypeShow: true,
        isStakeholderApprovalStatusShow: true,
        isTrainerReceptionistShow: true,
      }));
    } else if (from === 'subscription-extension') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isApprovalStatusShow: activeTab !== 'manual-extension',
        isLeadTableDatesShow: true,
      }));
    } else if (from === 'live-subscriptions') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isLeadTableDatesShow: true,
        isPlanTypesShow: true,
        isSearchShow: true,
        isShowHideBlock: true,
      }));
    } else if (from === 'recent-gym-activity') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isLeadStageShow: true,
        isLeadTableDatesShow: true,
      }));
    } else if (from === 'red-flag-alerts') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isLeadStageShow: true,
      }));
    } else if (from === 'closure-expected-tracker') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isLeadStageShow: true,
      }));
    } else if (from === 'agent-management') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isAgentShow: true,
        isLeadStageShow: true,
        isLeadTableDatesShow: true,
      }));
    } else if (from === 'agent-overview') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isAgentShow: true,
        isLeadStageShow: true,
      }));
    } else if (from === 'live-pt-trial-notifications' || from === 'live-bca-logs-notifications') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isLeadTableDatesShow: true,
        isSearchShow: true,
        isShowHideBlock: true,
        isOtherUserShow: isAdmin ? true : false,
        isStatusShow: true,
        isCheckinTimeShow: true,
        isRenewalShow: true,
        isStuckShow: true,
        isThreeDayTrialShow: true,
      }));
    } else if (from === 'member-checkin-logs') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isLeadTableDatesShow: true,
        isTrainerShow: true,
        isSearchShow: true,
        isShowHideBlock: true,
        isOtherUserShow: isAdmin ? true : false,
        isStatusShow: true,
        isExportBtnShow: onClickExportBtn ? true : false,
        isCheckinTimeShow: true,
        isRenewalShow: true,
        isStuckShow: true,
        isThreeDayTrialShow: true,
      }));
    } else if (from === 'renewal-reminder') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isLeadTableDatesShow: true,
        isPlanDurationShow: true,
        isExpiringInDaysShow: true,
        isSearchShow: true,
        isShowHideBlock: true,
        isOtherUserShow: isAdmin ? true : false,
        isStatusShow: true,
      }));
    } else if (from === 'home-global') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isReloadBtnShow: isReload ? true : false,
        isToggleFilterShow: true,
        isOtherUserShow: isAdmin ? true : false,
      }));
    } else if (from === 'regularization') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isTrainerReceptionistShow: true,
        isStaffTypeShow: true,
        isStatusShow: true,
      }));
    } else if (from === 'tme-attendance-analysis') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isMonthFilterShow: true,
        isStatusShow: true,
        isYearFilterShow: true,
        isReloadBtnShow: isReload ? true : false,
      }));
    } else if (from === 'unmapped-keywords') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isExportBtnShow: onClickExportBtn ? true : false,
      }));
    } else if (from === 'wtf-360-consultations') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isLeadTableDatesShow: true,
        isGymCityShow: true,
        isStatusShow: true,
      }));
    } else if (from === 'trainer-notification-logs') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        // isSearchShow: onClickSearch ? true : false,
        isLeadTableDatesShow: true,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isTrainerShow: true,
        isStatusShow: true,
      }));
    } else if (from === 'trainer-bca-evaluation') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isTrainerShow: true,
      }));
    } else if (from === 'odm-wtf-360') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isReloadBtnShow: isReload ? true : false,
        isLeadTableDatesShow: true,
        isSearchShow: onClickSearch ? true : false,
        // isAddedNotAddedToLeadFilterShow: true
      }));
    } else if (from === 'pre-sale-gym-leads') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        // isGymCityShow: true,
        isLeadTableDatesShow: true,
        isLeadStatusShow: true,
        isAddedNotAddedToLeadFilterShow: true,
      }));
    } else if (from === 'addons-categories') {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: onClickSearch ? true : false,
        isStatusShow: true,
      }));
    } else {
      setAllowedFilters(iniAllowedFilters);
    }
  }, [
    from,
    filters?.selUTMSource,
    filters?.selFollowupStage,
    clickedCard,
    selectedTab,
    filters?.selLeadSource,
    activeTab,
  ]);

  useEffect(() => {
    if (from === 'trainer-member-engagement') {
      if (selectedTab === 0) {
        setRangeStates((prevs) => ({
          ...prevs,
          approvalDate: [createDateRange('approvalDate')],
        }));
      } else {
        setRangeStates((prevs) => {
          const newState = { ...prevs };
          delete newState.approvalDate;
          return newState;
        });
      }

      if (selectedTab === 3) {
        setRangeStates((prevs) => ({
          ...prevs,
          expiredDate: [createDateRange('expiredDate')],
        }));
      } else {
        setRangeStates((prevs) => {
          const newState = { ...prevs };
          delete newState.expiredDate;
          return newState;
        });
      }
    } else if ((from === 'one-day-membership' && selectedTab === 3) || from === 'recurring-999') {
      setRangeStates((prevs) => {
        const newState = { ...prevs };
        delete newState.leadConvertedDate;
        return newState;
      });
    } else if (from === 'one-day-membership' && selectedTab !== 0) {
      setRangeStates((prevs) => ({
        ...prevs,
        leadConvertedDate: [createDateRange('leadConvertedDate')],
      }));
    }
  }, [selectedTab]);

  useEffect(() => {
    if (allowedFilters.isDashboardMenuShow) {
      getDashboardMenus();
    }
  }, [allowedFilters.isDashboardMenuShow]);

  useEffect(() => {
    if (allowedFilters.isDashboardFeatureShow) {
      getDashboardFeatures();
    }
  }, [allowedFilters.isDashboardFeatureShow, filters.selectedMenu]);

  useEffect(() => {
    if (allowedFilters.isGymShow) {
      dispatch(
        fetchGymData(
          userInfoData?.token,
          1,
          100,
          '',
          'all',
          ''
          // isManagerRole
          //   ? `&cluster_manager_id=${
          //       userInfoData?.user_id || userInfoData?.uid
          //     }`
          //   : ""
        )
      );
    }
  }, [allowedFilters.isGymShow]);

  useEffect(() => {
    if (allowedFilters.isCustomerIntentsShow) {
      const filtersToSend = {
        page: 1,
        limit: 10,
      };

      getCustomerIntent(filtersToSend);
    }
  }, [allowedFilters.isCustomerIntentsShow]);

  useEffect(() => {
    if (allowedFilters.isFollowupStatusShow) {
      const filtersToSend = {
        page: 1,
        limit: 1000,
        intent_id: filters.selCustomerIntent?.value || '',
      };

      getFollowupStatuses(filtersToSend);
    }
  }, [allowedFilters.isFollowupStatusShow]);

  useEffect(() => {
    if (
      allowedFilters.isAssignToFDShow ||
      allowedFilters.isOtherUserShow ||
      allowedFilters.isTrainerShow ||
      allowedFilters.isTrainerReceptionistShow ||
      allowedFilters.isFDShow ||
      allowedFilters.isTransferFromShow ||
      allowedFilters.isTransferToShow ||
      ((from === 'trainer-member-engagement' ||
        from === 'import-members' ||
        clickedCard === 'discount-payments') &&
        allowedFilters.isApprovalManagerShow) ||
      ((from === 'walkins-leads' || from === 'lead-management' || from === 'fresh-lead') &&
        allowedFilters.isAssignToShow)
    ) {
      const gymQP =
        clickedCard === 'discount-payments' || from === 'membership-pause'
          ? ''
          : from !== 'referrals' && filters?.selectedGym?.value
            ? `gym_id=${filters?.selectedGym.value}`
            : '';

      const filtertypeQP =
        from === 'trainer-member-engagement' || from === 'member-checkin-logs'
          ? `user_types=admin,trainer`
          : allowedFilters.isTrainerShow &&
              from !== 'pt-transfer-history' &&
              from !== 'member-checkin-logs'
            ? `user_types=trainer`
            : allowedFilters.isTrainerReceptionistShow && !filters?.selectedStaffType?.value
              ? `user_types=trainer,receptionist`
              : allowedFilters.isTrainerReceptionistShow && filters?.selectedStaffType?.value
                ? `user_types=${filters.selectedStaffType.value}`
                : from === 'lead-agent-report' && !filters?.accountType?.value
                  ? `user_types=trainer,receptionist,admin`
                  : from === 'lead-agent-report' && filters?.accountType?.value
                    ? `user_types=${filters?.accountType?.value}`
                    : allowedFilters.isFDShow || (from === 'raw-lead' && clickedCard === 'referral')
                      ? `user_types=receptionist`
                      : from === 'df' ||
                          from === 'um' ||
                          from === 'cash-reports' ||
                          from === 'membership-transfer' ||
                          from === 'walkins-leads' ||
                          (from === 'expense-management' && clickedCard === 0)
                        ? `user_types=admin,receptionist,trainer,cluster_manager`
                        : allowedFilters.isAccountTypeShow && filters?.accountType?.value
                          ? `user_types=${filters.accountType.value}`
                          : from === 'membership-pause' ||
                              from === 'live-pt-trial-notifications' ||
                              from === 'live-bca-logs-notifications' ||
                              from === 'member-checkin-logs' ||
                              from === 'renewal-reminder' ||
                              from === 'hygiene-taks-tabwise'
                            ? `user_types=admin`
                            : from === 'sales-value' ||
                                from === 'home-global' ||
                                from === 'agent-daily-target' ||
                                (from === 'expense-management' &&
                                  (clickedCard === 1 || clickedCard === 2 || clickedCard === 3))
                              ? 'user_types=cluster_manager'
                              : '';

      const finalQP = [gymQP, filtertypeQP]?.filter(Boolean)?.join('&');

      dispatch(
        fetchInHouseUsersData({
          token: userInfoData?.token,
          qps: finalQP,
          pageNo: 1,
          limit: 100,
        })
      );
    }
  }, [
    filters?.selectedGym,
    allowedFilters.isAssignToFDShow,
    allowedFilters.isTrainerShow,
    allowedFilters.isTrainerReceptionistShow,
    allowedFilters.isOtherUserShow,
    allowedFilters.isFDShow,
    filters?.accountType,
    filters?.selectedStaffType,
    allowedFilters.isApprovalManagerShow,
    allowedFilters.isAccountTypeShow,
    filters?.accountType,
    allowedFilters.isTransferFromShow,
    allowedFilters.isTransferToShow,
    allowedFilters.isAssignToShow,
    clickedCard,
  ]);

  useEffect(() => {
    if (allowedFilters.isAutomationKeywordsShow) {
      const sendableDilters = {
        limit: 1000,
        page: 1,
        is_dropdown: 1,
        gym_id: filters?.selectedGym?.value || '',
      };

      getAutomationKeyword(sendableDilters);
    }
  }, [allowedFilters.isAutomationKeywordsShow, filters?.selectedGym]);

  useEffect(() => {
    if (
      allowedFilters.isLeadFromShow &&
      from !== 'recurring-999' &&
      from !== 'one-day-membership'
    ) {
      getLeadFromSource();
    }
  }, [allowedFilters.isLeadFromShow]);

  useEffect(() => {
    if (allowedFilters.isLandingPageKeywordShow) {
      getLandingPages();
    }
  }, [allowedFilters.isLandingPageKeywordShow]);

  useEffect(() => {
    if (allowedFilters.isOperatorValueShow) {
      getOperatorValue();
    }
  }, [allowedFilters.isOperatorValueShow]);

  useEffect(() => {
    if (allowedFilters.isHygieneCategoryShow) {
      getHygieneTaskCategories();
    }
  }, [allowedFilters.isHygieneCategoryShow]);

  useEffect(() => {
    if (allowedFilters.isDynamicLeadSourceShow) {
      const filters = {
        limit: 2000,
        page: 1,
        is_rawlead: from === 'raw-lead' ? 1 : 0,
      };

      getLeadSources(filters);
    }
  }, [allowedFilters.isDynamicLeadSourceShow]);

  useEffect(() => {
    if (allowedFilters.isGymCityShow) {
      getGymCities();
    }
  }, [allowedFilters.isGymCityShow]);

  useEffect(() => {
    if (allowedFilters.isRawLeadFilterTypeShow) {
      getRawLeadStats();
    }
  }, [allowedFilters.isRawLeadFilterTypeShow]);

  useEffect(() => {
    if (allowedFilters.isBTLVendowShow) {
      getBTLVendors();
    }
  }, [allowedFilters.isBTLVendowShow]);

  useEffect(() => {
    if (allowedFilters.isFeatureGroupsShow) {
      getDashboardFeatureGrouping();
    }
  }, [allowedFilters.isFeatureGroupsShow]);

  useEffect(() => {
    if (
      allowedFilters.isUTMCampaignShow ||
      allowedFilters.isUTMMediumShow ||
      allowedFilters.isUTMContentShow ||
      allowedFilters.isUTMTermShow
    ) {
      const sendableFilters = {
        utm_source: filters?.selUTMSource?.value || '',
      };

      getUTMParameters(sendableFilters);
    }
  }, [
    allowedFilters.isUTMCampaignShow,
    allowedFilters.isUTMMediumShow,
    allowedFilters.isUTMContentShow,
    allowedFilters.isUTMTermShow,
    filters?.selUTMSource,
  ]);

  useEffect(() => {
    if (
      allowedFilters.isApprovalManagerShow &&
      from !== 'trainer-member-engagement' &&
      from !== 'import-members' &&
      clickedCard !== 'discount-payments'
    ) {
      getExpenseProcessManagers();
    }
  }, [allowedFilters.isApprovalManagerShow, clickedCard]);

  useEffect(() => {
    if (allowedFilters.isAPaidByShow) {
      getExpenseAccountants();
    }
  }, [allowedFilters.isAPaidByShow]);

  useEffect(() => {
    if (allowedFilters.isGymCategoryShow) {
      const sendableFilters = {
        page: 1,
        limit: 1000,
        status: 'active',
      };

      getPlansCategoriesData(sendableFilters);
    }
  }, [allowedFilters.isGymCategoryShow]);

  useEffect(() => {
    if (allowedFilters.isEmailTemplateShow) {
      const sendableEmailTemplateFilters = {
        page: 1,
        limit: 3000,
        status: 'active',
      };

      getEmailTemplates(sendableEmailTemplateFilters);
    }
  }, [allowedFilters.isEmailTemplateShow]);

  useEffect(() => {
    if (allowedFilters.isWPTemplateShow) {
      const sendableWPTemplateFilters = {
        page: 1,
        limit: 3000,
        status: 'APPROVED',
      };

      getWPTemplates(sendableWPTemplateFilters);
    }
  }, [allowedFilters.isWPTemplateShow]);

  useEffect(() => {
    if (allowedFilters.isWorkoutGoalsShow) {
      getWorkoutGoals();
    }
  }, [allowedFilters.isWorkoutGoalsShow]);

  useEffect(() => {
    if (customerIntentCategory?.status && customerIntentCategory?.data?.length > 0) {
      const allIntents = customerIntentCategory?.data?.map((item) => ({
        value: item?.uid || '',
        label: item?.name?.replace(/_/g, ' ') || '',
      }));

      setCustomerIntents(allIntents);
    } else {
      setCustomerIntents([]);
    }
  }, [customerIntentCategory]);

  useEffect(() => {
    if (followupStatuses?.status && followupStatuses?.data?.length > 0) {
      const allFollowups = followupStatuses.data.map((item) => {
        const intentNames = item?.intent_name
          ? item.intent_name.split(',').map((intent) => intent.trim().replace(/_/g, ' '))
          : ['default'];

        const primaryIntent =
          intentNames.find((intent) => intentColorMap[intent]) || intentNames[0];
        const color = getIntentColor(primaryIntent);

        return {
          value: item?.value || '',
          label: (
            <span className="followup-option">
              <span className="dot" style={{ backgroundColor: color }} />
              {`${item?.display_label?.replace(/_/g, ' ') || ''} (${intentNames.join(', ')})`}
            </span>
          ),
        };
      });

      setFollowupStatus(allFollowups);
    } else {
      setFollowupStatus([]);
    }
  }, [followupStatuses]);

  useEffect(() => {
    if (allowedFilters.isAutomationKeywordsShow && leadCaptureKeywords?.pagination?.length > 0) {
      setTotalPages(leadCaptureKeywords?.pagination?.[0]?.pagination || 1);
    } else {
      setTotalPages(1);
    }
  }, [leadCaptureKeywords]);

  useEffect(() => {
    if (allowedFilters.isHygieneCategoryShow && hygineTaskCategory?.data?.length > 0) {
      const allCats = hygineTaskCategory.data?.map((item) => ({
        value: item?.uid || '',
        label: item?.name || '',
        info: item,
      }));
      setHygieneCategoriesDropdown(allCats);
    } else {
      setHygieneCategoriesDropdown([]);
    }
  }, [hygineTaskCategory]);

  useEffect(() => {
    if (rawLeadStats?.status && rawLeadStats?.data) {
      const allData = rawLeadStats.data[0];

      const dropdownData = Object.keys(allData)
        .filter((key) => key !== 'added_from_trial')
        .map((key) => ({
          value: keyMapping[key] || getCardValue(key?.replace(/ /g, '_')),
          label: keyMapping[key] ? keyMapping[key].replace(/_/g, ' ') : getCardLabel(key),
        }));

      setAllDropdownData((prevs) => ({
        ...prevs,
        allFilterTypesData: dropdownData,
      }));
    } else {
      setAllDropdownData((prevs) => ({
        ...prevs,
        allFilterTypesData: [],
      }));
    }
  }, [rawLeadStats]);

  useEffect(() => {
    if (vendorsBTL?.status && vendorsBTL?.data && !vendorsBTLLoading && !vendorsBTLError) {
      const allData = vendorsBTL.data;

      const dropdownData = allData?.map((item) => ({
        value: item?.uid || '',
        label: item?.name || '',
      }));

      setAllDropdownData((prevs) => ({
        ...prevs,
        allBTLVendors: dropdownData,
      }));
    } else {
      setAllDropdownData((prevs) => ({
        ...prevs,
        allBTLVendors: [],
      }));
    }
  }, [vendorsBTL, vendorsBTLLoading, vendorsBTLError]);

  useEffect(() => {
    if (dashFeatureGrouping?.status && dashFeatureGrouping?.data) {
      const allData = dashFeatureGrouping.data;

      const dropdownData = allData?.map((item) => ({
        label: item?.name,
        value: item?.uid,
        info: item,
      }));

      setAllDropdownData((prevs) => ({
        ...prevs,
        allFeatureGroups: dropdownData,
      }));
    } else {
      setAllDropdownData((prevs) => ({
        ...prevs,
        allFeatureGroups: [],
      }));
    }
  }, [dashFeatureGrouping]);

  useEffect(() => {
    if (!filters?.selFollowupStage?.value) {
      setFilters((prevs) => ({
        ...prevs,
        isOperatorValueShow: '',
      }));
    }
  }, [filters?.selFollowupStage]);

  useEffect(() => {
    if (filters.clickedCard === 'closure_expected_today') {
      setFilters((prevs) => ({
        ...prevs,
        leadFollowupDateFrom: currentMonthCurrentDate,
        leadFollowupDateTo: currentMonthCurrentDate,
      }));
    } else if (filters.clickedCard === 'closure_expected_tomorrow') {
      setFilters((prevs) => ({
        ...prevs,
        leadFollowupDateFrom: currentMonthTomorrowDate,
        leadFollowupDateTo: currentMonthTomorrowDate,
      }));
    }
  }, [filters.clickedCard]);

  useEffect(() => {
    if (
      (filters.clickedCard === 'closure_expected_today' ||
        filters.clickedCard === 'closure_expected_tomorrow') &&
      customerIntents?.length > 0
    ) {
      setFilters((prevs) => ({
        ...prevs,

        selCustomerIntent: customerIntents.find((int) => int.label?.toLowerCase() === 'interested')
          ? customerIntents.find((int) => int.label?.toLowerCase() === 'interested')
          : '',
      }));
    }
  }, [filters.clickedCard, customerIntents]);

  useEffect(() => {
    if (
      (filters.clickedCard === 'closure_expected_today' ||
        filters.clickedCard === 'closure_expected_tomorrow') &&
      filters.selCustomerIntent &&
      followupStatus?.length > 0
    ) {
      setFilters((prevs) => ({
        ...prevs,
        selFollowupStatus: followupStatus.find((int) => int.value === 'closure_expected')
          ? followupStatus.find((int) => int.value === 'closure_expected')
          : '',
      }));
    }
  }, [filters.clickedCard, filters.selCustomerIntent, followupStatus]);

  useEffect(() => {
    if (
      filters.clickedCard === 'closure_expected_today' &&
      filters.leadFollowupDateFrom &&
      filters.leadFollowupDateTo
    ) {
      if (
        filters.leadFollowupDateFrom !== currentMonthCurrentDate ||
        filters.leadFollowupDateTo !== currentMonthCurrentDate
      ) {
        setFilters((prevs) => ({
          ...prevs,
          clickedCard: '',
        }));
        setActiveCardIndex(null);
      }
    } else if (
      filters.clickedCard === 'closure_expected_tomorrow' &&
      filters.leadFollowupDateFrom &&
      filters.leadFollowupDateTo
    ) {
      if (
        filters.leadFollowupDateFrom !== currentMonthTomorrowDate ||
        filters.leadFollowupDateTo !== currentMonthTomorrowDate
      ) {
        setFilters((prevs) => ({
          ...prevs,
          clickedCard: '',
        }));
        setActiveCardIndex(null);
      }
    }
  }, [filters.clickedCard, filters.leadFollowupDateFrom, filters.leadFollowupDateTo]);

  useEffect(() => {
    if (
      allowedFilters.isDashboardMenuShow &&
      dashboardMenus?.status &&
      dashboardMenus?.data?.length > 0
    ) {
      const allmenus = dashboardMenus.data?.map((blog) => {
        return { label: blog?.menu_name, value: blog?.menu_id, info: blog };
      });

      setAllMenus(allmenus);
    } else {
      setAllMenus([]);
    }
  }, [allowedFilters.isDashboardMenuShow, dashboardMenus]);

  useEffect(() => {
    if (
      allowedFilters.isDashboardFeatureShow &&
      dashboardFeatures?.status &&
      dashboardFeatures?.data?.length > 0
    ) {
      const allmenus = dashboardFeatures.data?.map((blog) => {
        return { label: blog?.name, value: blog?.uid, info: blog };
      });

      setAllFeatures(allmenus);
    } else {
      setAllFeatures([]);
    }
  }, [allowedFilters.isDashboardFeatureShow, dashboardFeatures]);

  useEffect(() => {
    if (allowedFilters.isExpenseCategoryShow) {
      getExpenseCategories();
    }
  }, [allowedFilters.isExpenseCategoryShow]);

  useEffect(() => {
    if (
      allowedFilters.isExpenseCategoryShow &&
      expenseCategories?.status &&
      expenseCategories?.data?.length > 0
    ) {
      const allCategories = expenseCategories.data?.map((category) => {
        return { label: category?.name, value: category?.uid, info: category };
      });

      setAllExpenseCategories(allCategories);
    } else {
      setAllExpenseCategories([]);
    }
  }, [allowedFilters.isExpenseCategoryShow, expenseCategories]);

  useEffect(() => {
    if (
      !centralisedPlanCategoriesLoading &&
      !centralisedPlanCategoriesError &&
      centralisedPlanCategories?.status &&
      centralisedPlanCategories?.data?.length > 0
    ) {
      const allCategories = centralisedPlanCategories.data?.map((category) => {
        return { label: category?.name, value: category?.uid, info: category };
      });

      setAllGymCategories(allCategories);
    } else {
      setAllGymCategories([]);
    }
  }, [centralisedPlanCategoriesLoading, centralisedPlanCategoriesError, centralisedPlanCategories]);

  useEffect(() => {
    if (
      !broadcastTemplatesLoading &&
      !broadcastTemplatesError &&
      broadcastTemplates?.status &&
      broadcastTemplates?.data?.length > 0
    ) {
      const dropdownOptions = broadcastTemplates.data.map((item) => ({
        label: item.template_name?.replace(/_/g, ' '),
        value: item.template_name,
        info: item,
      }));

      setAllDropdownData((prevs) => ({
        ...prevs,
        allEmailTemplates: dropdownOptions,
      }));
    } else {
      setAllDropdownData((prevs) => ({
        ...prevs,
        allEmailTemplates: [],
      }));
    }
  }, [broadcastTemplates, broadcastTemplatesLoading, broadcastTemplatesError]);

  useEffect(() => {
    if (
      !broadcastWPTemplatesLoading &&
      !broadcastWPTemplatesError &&
      broadcastWPTemplates?.status &&
      broadcastWPTemplates?.data?.length > 0
    ) {
      const dropdownOptions = broadcastWPTemplates.data.map((item) => ({
        label: item.elementName?.replace(/_/g, ' '),
        value: item.elementName,
        info: item,
      }));

      setAllDropdownData((prevs) => ({
        ...prevs,
        allWPTemplates: dropdownOptions,
      }));
    } else {
      setAllDropdownData((prevs) => ({
        ...prevs,
        allWPTemplates: [],
      }));
    }
  }, [broadcastWPTemplates, broadcastWPTemplatesLoading, broadcastWPTemplatesError]);

  useEffect(() => {
    if (
      !gymLandingPagesLoading &&
      !gymLandingPagesError &&
      gymLandingPages?.status &&
      gymLandingPages?.data
    ) {
      const allData = gymLandingPages.data;

      const dropdownData = allData?.map((item) => ({
        value: item?.keyword || '',
        label: item?.keyword || '',
      }));

      setAllDropdownData((prevs) => ({
        ...prevs,
        allLandingPages: dropdownData,
      }));
    } else {
      setAllDropdownData((prevs) => ({
        ...prevs,
        allLandingPages: [],
      }));
    }
  }, [gymLandingPages, gymLandingPagesLoading, gymLandingPagesError]);

  return (
    <>
      <div
        className={`cmnFilterStructureContainer ${!allowedFilters.isCardBlockShow ? 'grid-2' : ''}`}
        style={{ marginTop: '1rem' }}
      >
        {allowedFilters.isCardBlockShow ? <CmnFilterCardBlock /> : null}

        <div className={`filterblock gridSpanTwo`}>
          {allowedFilters.isDateRangerShow && openDateRanger && (
            <DateRanger
              handleDateRangeChange={handleDateRangeChange}
              rangeState={rangeState}
              onClose={() => setOpenDateRanger(false)}
              onClear={clearDateRanger}
            />
          )}

          <div className="filterHeadingNBtn">
            <h5 className="filterHeading">
              {allowedFilters.isShowHideBlock ? (
                <button
                  type="button"
                  className="pt-track-dropdown-toggle"
                  onClick={() =>
                    setFilters((prevs) => ({
                      ...prevs,
                      showFiltersDropdown: !prevs.showFiltersDropdown,
                    }))
                  }
                >
                  {filters?.showFiltersDropdown ? (
                    <UpIcon />
                  ) : (
                    <DownIcon color={hasActiveFilters() ? 'red' : ''} />
                  )}
                </button>
              ) : null}{' '}
              {isSegment ? 'Create Segment' : 'All Filters'}
            </h5>

            <div className="filterHeadingBtnBlock lastOne">
              {allowedFilters.isInfoTxtShow ? (
                <div className="infoBox flexEnd">
                  <button
                    type="button"
                    className="infoBtn"
                    onClick={() => setShowInfoTxt(!showInfoTxt)}
                  >
                    {showInfoTxt && <span className="info">{infoTxt}</span>}
                    <InfoCircleIcon />
                  </button>
                </div>
              ) : null}

              {allowedFilters.isReloadBtnShow ? (
                <button
                  type="button"
                  variant="dark"
                  onClick={isReload}
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '50%',
                    border: 'none',
                    backgroundColor: '#000',
                    cursor: 'pointer',
                    color: '#fff',
                  }}
                >
                  <ArrowClockwiseIcon />
                </button>
              ) : null}

              {allowedFilters.isToggleFilterShow ? (
                <div className="checkbox-btns">
                  <Form.Check
                    type="switch"
                    name="isToggledValue"
                    label={
                      from === 'home-global'
                        ? filters.isToggledValue
                          ? 'Switch To Normal Mode'
                          : 'Switch To Beta Mode'
                        : 'Switch To LMS'
                    }
                    checked={filters.isToggledValue}
                    onChange={(event) =>
                      setFilters({
                        ...filters,
                        isToggledValue: event.target.checked,
                      })
                    }
                  />
                </div>
              ) : null}

              {allowedFilters.isWatiCredsShow ? (
                <CustomFilterTopInfo label={'Wati Credits'} value={watiCreds} />
              ) : null}

              {allowedFilters.isBroadcastBtnShow ? (
                <RedButton
                  btnName={'Broadcast Campaign'}
                  onClickBtn={onClickBroadcastBtn}
                  isDark={true}
                />
              ) : null}

              {allowedFilters.isExportBtnShow ? (
                exportLoading ? (
                  <button className="btn-k red-bg-k" disabled>
                    <DotLoaders color="#fff" />
                  </button>
                ) : csvData ? (
                  <CSVLink
                    data={csvData}
                    filename={csvFileName || 'export_data.csv'}
                    className="decoration-none-k"
                    style={{
                      backgroundColor: '#3396d3',
                      color: '#fff',
                      padding: '8px 16px',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                    }}
                    onClick={onClickExportBtn}
                  >
                    Download CSV
                  </CSVLink>
                ) : (
                  <RedButton btnName="Export Data" onClickBtn={onClickExportBtn} />
                )
              ) : null}

              {allowedFilters.isPtInterestToggleShow ? (
                <Form.Check
                  type="switch"
                  name="isPTInterested"
                  className={`toggle-switch-with-reset-btn ${
                    filters.isPTInterested ? 'active' : ''
                  }`}
                  label={'PT Interested'}
                  checked={filters.isPTInterested}
                  onChange={(event) =>
                    setFilters({
                      ...filters,
                      isPTInterested: event.target.checked,
                    })
                  }
                />
              ) : null}

              {allowedFilters.isFitnessProfileToggleShow ? (
                <Form.Check
                  type="switch"
                  name="isFitnessProfileCompleted"
                  className={`toggle-switch-with-reset-btn ${
                    filters.isFitnessProfileCompleted ? 'active' : ''
                  }`}
                  label={'Fitness Profile Completed'}
                  checked={filters.isFitnessProfileCompleted}
                  onChange={(event) =>
                    setFilters({
                      ...filters,
                      isFitnessProfileCompleted: event.target.checked,
                    })
                  }
                />
              ) : null}

              <Button type="button" variant="outline-danger" onClick={onClickReset}>
                Reset Filter
              </Button>
            </div>
          </div>

          {(from !== 'live-subscriptions' &&
            from !== 'live-pt-trial-notifications' &&
            from !== 'live-bca-logs-notifications' &&
            from !== 'member-checkin-logs' &&
            from !== 'renewal-reminder') ||
          ((from === 'live-subscriptions' ||
            from === 'live-pt-trial-notifications' ||
            from === 'live-bca-logs-notifications' ||
            from === 'member-checkin-logs' ||
            from === 'renewal-reminder') &&
            filters.showFiltersDropdown) ? (
            <div
              className={`filtersDropdown ${from} ${
                from === 'raw-lead'
                  ? 'grid-4'
                  : from === 'sales-value' ||
                      from === 'home-global' ||
                      from === 'tme-attendance-analysis'
                    ? 'grid-3'
                    : 'grid-5'
              }`}
            >
              {allowedFilters.isDateRangerShow && (
                <>
                  <div
                    className={`commonWrapper dropdownCommonWrapper darerangerCommonWrapper ${
                      filters?.selectedStartDate || filters?.selectedEndDate
                        ? 'redBorderRedText'
                        : ''
                    }`}
                  >
                    {openDateRanger ? (
                      <div className="closeAndClearDateRangerButtons">
                        <button
                          type="button"
                          className="closeClearBtn notmalButtonStyles noStyle closeRangerBtn"
                          onClick={() => setOpenDateRanger(false)}
                          style={{ textAlign: 'center' }}
                        >
                          <BiCheckIcon />
                          Close
                        </button>
                        <button
                          type="button"
                          className="closeClearBtn notmalButtonStyles noStyle clearRangerBtn"
                          onClick={clearDateRanger}
                          style={{ textAlign: 'center' }}
                        >
                          <BiXIcon />
                          Clear
                        </button>
                      </div>
                    ) : filters?.selectedStartDate || filters?.selectedEndDate ? (
                      <div className="flex-between">
                        <button
                          type="button"
                          className="notmalButtonStyles noStyle long_one"
                          style={{ textAlign: 'center' }}
                          onClick={() => setOpenDateRanger(true)}
                        >
                          <span className="dates">
                            {moment(filters?.selectedStartDate)
                              .tz('Asia/Kolkata')
                              .format('DD-MM-YYYY')}
                          </span>
                          <small>TO</small>
                          <span className="dates">
                            {moment(filters?.selectedEndDate)
                              .tz('Asia/Kolkata')
                              .format('DD-MM-YYYY')}
                          </span>
                        </button>

                        <button
                          type="button"
                          className="notmalButtonStyles noStyle short_one"
                          onClick={() => clearDateRanger()}
                        >
                          <span className="icon calender">
                            <RedCrossIcon />
                          </span>
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        className="notmalButtonStyles noStyle"
                        onClick={() =>
                          filters?.selectedStartDate || filters?.selectedEndDate
                            ? clearDateRanger()
                            : setOpenDateRanger(true)
                        }
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          gap: '1rem',
                        }}
                      >
                        {getDateRangerLableSingle(from)}

                        <span className="icon calender">
                          {filters?.selectedStartDate || filters?.selectedEndDate ? (
                            <CrossIcon />
                          ) : (
                            <DateRangerIcon1 />
                          )}
                        </span>
                      </button>
                    )}
                  </div>
                </>
              )}

              {allowedFilters.isLeadTableDatesShow && (
                <>
                  {Object.keys(rangeStates).map((rangeKey, index) => (
                    <React.Fragment key={rangeKey}>
                      {activeDateRanges[rangeKey] && (
                        <DateRanger
                          handleDateRangeChange={(item) =>
                            handleDateRangeChangeMulti(item, rangeKey)
                          }
                          rangeState={rangeStates[rangeKey]}
                          onClose={() =>
                            setActiveDateRanges((prevActiveDateRanges) => ({
                              ...prevActiveDateRanges,
                              [rangeKey]: false,
                            }))
                          }
                          onClear={() => clearDateRangerMulti(rangeKey)}
                        />
                      )}

                      <div
                        className={`commonWrapper dropdownCommonWrapper darerangerCommonWrapper ${
                          (filters[`${rangeKey}From`] || filters[`${rangeKey}To`]) &&
                          'redBorderRedText'
                        }`}
                      >
                        {activeDateRanges[rangeKey] ? (
                          <div className="closeAndClearDateRangerButtons">
                            <button
                              type="button"
                              className="closeClearBtn notmalButtonStyles noStyle closeRangerBtn"
                              onClick={() =>
                                setActiveDateRanges((prevActiveDateRanges) => ({
                                  ...prevActiveDateRanges,
                                  [rangeKey]: false,
                                }))
                              }
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="closeClearBtn notmalButtonStyles noStyle clearRangerBtn"
                              onClick={() => clearDateRangerMulti(rangeKey)}
                            >
                              Clear
                            </button>
                          </div>
                        ) : (
                          <div className="flex-between">
                            <button
                              type="button"
                              className="notmalButtonStyles noStyle long_one"
                              onClick={() => {
                                setActiveDateRanges((prevActiveDateRanges) => ({
                                  ...Object.keys(prevActiveDateRanges).reduce((acc, key) => {
                                    acc[key] =
                                      key === rangeKey ? !prevActiveDateRanges[key] : false;
                                    return acc;
                                  }, {}),
                                }));
                              }}
                              disabled={isLoading}
                            >
                              {filters[`${rangeKey}From`] || filters[`${rangeKey}To`]
                                ? `${moment(filters[`${rangeKey}From`])
                                    .tz('Asia/Kolkata')
                                    .format('DD-MM-YYYY')} - ${moment(filters[`${rangeKey}To`])
                                    .tz('Asia/Kolkata')
                                    .format('DD-MM-YYYY')}`
                                : getDateRangerLable(
                                    rangeKey === 'leadAddDate' && from === 'raw-lead'
                                      ? 'rawLeadAddDate'
                                      : rangeKey,
                                    from
                                  )}
                            </button>
                            <button
                              type="button"
                              className="notmalButtonStyles noStyle short_one"
                              onClick={() => {
                                clearDateRangerMulti(rangeKey);
                              }}
                              disabled={isLoading}
                            >
                              <span className="icon calender">
                                {filters[`${rangeKey}From`] || filters[`${rangeKey}To`] ? (
                                  <RedCrossIcon />
                                ) : (
                                  <DateRangerIcon
                                    color={`${
                                      filters[`${rangeKey}From`] || filters[`${rangeKey}To`]
                                        ? 'green'
                                        : '#898989'
                                    }`}
                                  />
                                )}
                              </span>
                            </button>
                          </div>
                        )}
                      </div>
                    </React.Fragment>
                  ))}
                </>
              )}

              {allowedFilters.isSignleDateShow && (
                <div className="filtersDropdown">
                  <SingleDatePicker filters={filters} setFilters={setFilters} />
                </div>
              )}

              {allowedFilters.isGymShow && (
                <>
                  {isSegment ? (
                    <div
                      className={`commonWrapper dropdownCommonWrapper multiselect-filter ${
                        filters?.selectedGyms?.length > 0 ? 'redBorderRedText' : ''
                      }  ${from === 'home-global' ? 'span2' : ''}`}
                    >
                      <MultiSelect
                        options={gymData}
                        state={filters?.selectedGyms}
                        setState={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedGyms: selectedValue,
                          })
                        }
                        name="Gym"
                      />
                    </div>
                  ) : (
                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedGym?.value ? 'redBorderRedText' : ''
                      } ${
                        from === 'home-global' ||
                        from === 'regularization' ||
                        from === 'trainer-member-engagement' ||
                        from === 'trainer-bca-evaluation'
                          ? 'span2'
                          : ''
                      }`}
                    >
                      <SelectDropdownLabel
                        options={gymData?.length > 0 ? gymData : []}
                        selectedOption={filters?.selectedGym}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedGym: selectedValue,
                          })
                        }
                        name={
                          clickedCard === 'gym-transfer'
                            ? 'Transfer From (Gym)'
                            : from === 'staff-onboarding'
                              ? 'Select gym'
                              : 'Gym'
                        }
                        isDisable={isLoading}
                      />
                    </div>
                  )}
                </>
              )}

              {allowedFilters.isLeadTypeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selCard?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={leadCustomerCategories}
                    selectedOption={filters?.selCard}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selCard: selectedValue,
                      })
                    }
                    name="Lead Type"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isLeadStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selLeadStatus?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={leadClosingOPeningStatuses}
                    selectedOption={filters?.selLeadStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selLeadStatus: selectedValue,
                      })
                    }
                    name="Lead Status"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isCustomerIntentsShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selCustomerIntent?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={customerIntents}
                    selectedOption={filters?.selCustomerIntent}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selCustomerIntent: selectedValue,
                        selFollowupStatus: '',
                      })
                    }
                    name="Customer Intent"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isFollowupStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selFollowupStatus?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={followupStatus}
                    selectedOption={filters?.selFollowupStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selFollowupStatus: selectedValue,
                      })
                    }
                    name="Follow-up Status"
                    // preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isFollowupStageShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selFollowupStage?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={leadFollowupStages}
                    selectedOption={filters?.selFollowupStage}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selFollowupStage: selectedValue,
                      })
                    }
                    name="Followup Stage"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isOperatorValueShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selOperatorValue?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={operatorValue?.length > 0 ? operatorValue : []}
                    selectedOption={filters?.selOperatorValue}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selOperatorValue: selectedValue,
                      })
                    }
                    name="Operator Value"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isFollowupTimesShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper multiselect-filter multi-select-max-width ${
                    filters?.selFollowupTime?.length > 0 ? 'redBorderRedText' : ''
                  }`}
                >
                  <MultiSelect
                    options={timeSlotsQuarter}
                    state={filters?.selFollowupTime}
                    setState={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selFollowupTime: selectedValue,
                      })
                    }
                    name="Followup Time"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isLeadPlanTypesShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.setPlan?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={leadPlanTypes}
                    selectedOption={filters?.setPlan}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        setPlan: selectedValue,
                      })
                    }
                    name="Plan"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isAutomationKeywordsShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selAutomationKeyword?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={leadCaptureKeywords?.dropdown || []}
                    selectedOption={filters?.selAutomationKeyword}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selAutomationKeyword: selectedValue,
                      })
                    }
                    name="Keyword Name"
                    isDisable={isLoading}
                    // onSearchChange={handleSearchChange}
                    // fetchMoreData={fetchMoreData}
                    // fetchPreviousData={fetchPreviousData}
                  />
                </div>
              )}

              {allowedFilters.isHygieneCategoryShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedHygineCategory?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={hygieneCategoriesDropdown}
                    selectedOption={filters?.selectedHygineCategory}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedHygineCategory: selectedValue,
                      })
                    }
                    name="Task Category"
                  />
                </div>
              )}

              {allowedFilters.isHygieneTaskPriorityShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedTaskPriority?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={TASK_PRIORITY}
                    selectedOption={filters?.selectedTaskPriority}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedTaskPriority: selectedValue,
                      })
                    }
                    name="Task Priority"
                  />
                </div>
              )}

              {allowedFilters.isTaskIntervalShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selTaskInterval?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={hygine_task_frequency_categories}
                    selectedOption={filters?.selTaskInterval}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selTaskInterval: selectedValue,
                      })
                    }
                    name="Interval"
                  />
                </div>
              )}

              {allowedFilters.isMediaTypeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selMediaType?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={hygieneMeadiaTypes}
                    selectedOption={filters?.selMediaType}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selMediaType: selectedValue,
                      })
                    }
                    name="Media Type"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isAssignToShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selAssignee?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      clickedCard === 'referral' || from === 'walkins-leads'
                        ? inhouseUsers?.length > 0
                          ? inhouseUsers
                          : []
                        : from === 'lead-management' || from === 'fresh-lead'
                          ? inhouseUsers?.length > 0
                            ? inhouseUsers?.filter((value) => !value?.label?.includes('trainer'))
                            : []
                          : from === 'hygiene-taks-tabwise'
                            ? trainer_receptionist_both
                            : hygieneAsignee
                    }
                    selectedOption={filters?.selAssignee}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selAssignee: selectedValue,
                      })
                    }
                    name={
                      clickedCard === 'referral'
                        ? 'Assign To'
                        : from === 'hygiene-taks' ||
                            from === 'hygine-submitted-tasks' ||
                            from === 'hygine-tasks-approval' ||
                            from === 'training'
                          ? 'Select Role'
                          : from === 'walkins-leads'
                            ? 'Select Assisted By'
                            : from === 'lead-management'
                              ? 'Assign To'
                              : from === 'hygiene-taks-tabwise'
                                ? 'Stakeholders'
                                : 'Select Assignee'
                    }
                  />
                </div>
              )}

              {allowedFilters.isAssigneeStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedAssigneeStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={active_deleted}
                    selectedOption={filters?.selectedAssigneeStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedAssigneeStatus: selectedValue,
                      })
                    }
                    name="Assigned To Status"
                  />
                </div>
              )}

              {allowedFilters.isStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.isActive?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      from === 'one-day-membership'
                        ? one_day_membership_status
                        : from === 'df'
                          ? dfPaymentStatus
                          : from === 'expense-management'
                            ? expense_statuses
                            : from === 'referrals'
                              ? referral_statuses
                              : from === 'gym-members' ||
                                  from === 'um' ||
                                  from === 'health-tracking'
                                ? subscription_status
                                : from === 'hygine-tasks-approval' ||
                                    from === 'hygine-submitted-tasks'
                                  ? TASK_APPROVAL_STATUS
                                  : from === 'staff-onboarding'
                                    ? ONBOARDING_STATUS
                                    : from === 'broadcast-wp-templates'
                                      ? wp_template_status
                                      : from === 'bca-report' ||
                                          from === 'bca-logs' ||
                                          from === 'fitness-profile-logs'
                                        ? bca_status
                                        : from === 'trainer-member-engagement'
                                          ? bca_status_tme
                                          : from === 'broadcasts-logs-listings' ||
                                              clickedCard === 'scheduled-broadcast-logs'
                                            ? broadcast_logs_status
                                            : from === 'fitness-profile-logs'
                                              ? new_existing_member
                                              : from === 'live-pt-trial-notifications' ||
                                                  from === 'live-bca-logs-notifications' ||
                                                  from === 'member-checkin-logs' ||
                                                  from === 'renewal-reminder'
                                                ? resolution_status
                                                : from === 'regularization'
                                                  ? regularization_approval_status
                                                  : from === 'tme-attendance-analysis'
                                                    ? tme_analysis_attendance_checkin_status
                                                    : from === 'wtf-360-consultations'
                                                      ? wtf_360_consultation_statuses
                                                      : from === 'trainer-notification-logs'
                                                        ? trainer_notification_log_statuses
                                                        : activeInactiveStatus
                    }
                    selectedOption={filters?.isActive}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        isActive: selectedValue,
                      })
                    }
                    name={
                      from === 'staff-onboarding' || from === 'regularization'
                        ? 'Approval Status'
                        : from === 'one-day-membership'
                          ? 'Plan Status'
                          : from === 'membership-pause'
                            ? 'Pause Status'
                            : from === 'bca-report' ||
                                from === 'bca-logs' ||
                                clickedCard === 'bca-logs'
                              ? 'BCA Status'
                              : from === 'trainer-member-engagement'
                                ? 'First BCA'
                                : from === 'broadcasts-logs-listings'
                                  ? 'Broadcast Status'
                                  : from === 'fitness-profile-logs'
                                    ? 'Fitness Profile Status'
                                    : from === 'live-pt-trial-notifications' ||
                                        from === 'live-bca-logs-notifications' ||
                                        from === 'member-checkin-logs' ||
                                        from === 'renewal-reminder'
                                      ? 'Resolution Status'
                                      : from === 'tme-attendance-analysis'
                                        ? 'Checkin Status'
                                        : 'Status'
                    }
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isBCAStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedBCAStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      from === 'three-day-trial'
                        ? bca_status.slice(0, 2)
                        : from === 'health-tracking'
                          ? trainer_rating
                          : bca_status
                    }
                    selectedOption={filters?.selectedBCAStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedBCAStatus: selectedValue,
                      })
                    }
                    name={from === 'health-tracking' ? 'BCA Status' : 'Current BCA Status'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isAssignedStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedAssignedStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={three_day_assigned}
                    selectedOption={filters?.selectedAssignedStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedAssignedStatus: selectedValue,
                      })
                    }
                    name={'3 Day Trial Status'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isDayNoShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedDayNo?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={three_day_day_no}
                    selectedOption={filters?.selectedDayNo}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedDayNo: selectedValue,
                      })
                    }
                    name={'Day Number'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isCompletedCountShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedCompletedCount?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={three_day_completed_count}
                    selectedOption={filters?.selectedCompletedCount}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedCompletedCount: selectedValue,
                      })
                    }
                    name={'Completed Sessions'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isSlotTimeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedSlotTime?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={three_day_slot_time}
                    selectedOption={filters?.selectedSlotTime}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedSlotTime: selectedValue,
                      })
                    }
                    name={'Slot Time'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isClaimAtGymShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedClaimAtGym?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={inventory_claim_status}
                    selectedOption={filters?.selectedClaimAtGym}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedClaimAtGym: selectedValue,
                      })
                    }
                    name={'Claim'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isOnboardingStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedOnboardingStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={biomaxAppRegisterStatus}
                    selectedOption={filters?.selectedOnboardingStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedOnboardingStatus: selectedValue,
                      })
                    }
                    name={'Onboarding Status'}
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isUTMLeadSourceShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selUTMSource?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={UTMSources}
                    selectedOption={filters?.selUTMSource}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selUTMSource: selectedValue,
                        selUTMMedium: '',
                        selUTMContent: '',
                        selUTMTerm: '',
                        selUTMCampaign: '',
                      })
                    }
                    name="UTM Source"
                  />
                </div>
              )}

              {allowedFilters.isDynamicLeadSourceShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selLeadSource?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownDynamic
                    options={
                      dynamic_lead_sources?.data?.length > 0 ? dynamic_lead_sources.data : []
                    }
                    selectedOption={filters?.selLeadSource}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selLeadSource: selectedValue,
                        selectedVendor: '',
                      })
                    }
                    name="Lead Source"
                    onSearchChange={handleSearchChange}
                    fetchMoreData={fetchMoreData}
                    fetchPreviousData={fetchPreviousData}
                    isDisable={clickedCard === 'referral'}
                  />
                </div>
              )}

              {allowedFilters.isBTLVendowShow && (
                <>
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedVendor?.value ? 'redBorderRedText' : ''
                    }`}
                  >
                    <SelectDropdown
                      options={allDropdownData.allBTLVendors}
                      selectedOption={filters?.selectedVendor}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedVendor: selectedValue,
                        })
                      }
                      name={'Vendor'}
                      isDisable={isLoading}
                    />
                  </div>
                </>
              )}

              {allowedFilters.isGymCityShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selCity?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={gymCities?.length > 0 ? gymCities : []}
                    selectedOption={filters?.selCity}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selCity: selectedValue,
                      })
                    }
                    name={from === 'wtf-360-consultations' ? 'Preferred City' : 'City'}
                  />
                </div>
              )}

              {allowedFilters.isRawLeadFilterTypeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selFilterType?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={allDropdownData.allFilterTypesData}
                    selectedOption={filters?.selFilterType}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selFilterType: selectedValue,
                      })
                    }
                    name="Filter Type"
                    // preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isFromRawLeadShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selIsRaw?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={raw_lead_from}
                    selectedOption={filters?.selIsRaw}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selIsRaw: selectedValue,
                      })
                    }
                    name="Lead From"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isLeadStageShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedLeadStage?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={lead_stage}
                    selectedOption={filters?.selectedLeadStage}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedLeadStage: selectedValue,
                      })
                    }
                    name="Lead Stage"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isLeadFromShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selLeadFrom?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      from === 'recurring-999' || from === 'one-day-membership'
                        ? odm_lead_from
                        : leadFromSource?.length > 0
                          ? leadFromSource
                          : leadFrom
                    }
                    selectedOption={filters?.selLeadFrom}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selLeadFrom: selectedValue,
                      })
                    }
                    name="Lead From"
                    // preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isLandingPageKeywordShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedLandingPageKeyword?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={allDropdownData.allLandingPages}
                    selectedOption={filters?.selectedLandingPageKeyword}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedLandingPageKeyword: selectedValue,
                      })
                    }
                    name="Landing Page Name"
                  />
                </div>
              )}

              {allowedFilters.isConvertedToShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper multiselect-filter multi-select-max-width ${
                    filters?.selConvertedIn?.length > 0 ? 'redBorderRedText' : ''
                  }`}
                >
                  <MultiSelect
                    options={daysAfterUptoYear}
                    state={filters?.selConvertedIn}
                    setState={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selConvertedIn: selectedValue,
                      })
                    }
                    name="Converted In Days"
                  />
                </div>
              )}

              {allowedFilters.isTransferFromShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedTransferFrom?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      inhouseUsers?.length > 0
                        ? inhouseUsers?.filter((value) => value?.label?.includes('trainer'))
                        : []
                    }
                    selectedOption={filters?.selectedTransferFrom}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedTransferFrom: selectedValue,
                      })
                    }
                    name="PT Transferred From"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isTransferToShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedTransferTo?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      inhouseUsers?.length > 0
                        ? inhouseUsers?.filter((value) => value?.label?.includes('trainer'))
                        : []
                    }
                    selectedOption={filters?.selectedTransferTo}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedTransferTo: selectedValue,
                      })
                    }
                    name="PT Transferred To"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isTrainerShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedTrainer?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      from === 'trainer-member-engagement' ||
                      from === 'pt-transfer-history' ||
                      from === 'member-checkin-logs'
                        ? inhouseUsers?.length > 0
                          ? inhouseUsers?.filter((value) => value?.label?.includes('trainer'))
                          : []
                        : inhouseUsers?.length > 0
                          ? inhouseUsers
                          : []
                    }
                    selectedOption={filters?.selectedTrainer}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedTrainer: selectedValue,
                      })
                    }
                    name={`${
                      from === 'pt-transfer-history'
                        ? 'transferred to'
                        : from === 'bca-report'
                          ? 'Select Trainer'
                          : 'Trainer'
                    }`}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isPtInterestShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedPtInterest?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={pt_interest}
                    selectedOption={filters?.selectedPtInterest}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedPtInterest: selectedValue,
                      })
                    }
                    name="Interest For PT"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isFitnessProfileStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedFitnessProfileStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={from === 'health-tracking' ? trainer_rating : biomaxAppRegisterStatus}
                    selectedOption={filters?.selectedFitnessProfileStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedFitnessProfileStatus: selectedValue,
                      })
                    }
                    name={
                      from === 'couple-membership-request'
                        ? 'Document Status'
                        : from === 'staff-onboarding'
                          ? 'Select Biomax Status'
                          : from === 'health-tracking'
                            ? 'Profiling Status'
                            : 'Fitness Profile'
                    }
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isTrainerRatingStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedTrainerRatingStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={trainer_rating}
                    selectedOption={filters?.selectedTrainerRatingStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedTrainerRatingStatus: selectedValue,
                      })
                    }
                    name="Trainer Rating Status"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isStaffTypeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedStaffType?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={staff_types}
                    selectedOption={filters?.selectedStaffType}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedStaffType: selectedValue,
                      })
                    }
                    name="Staff Type"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isTrainerReceptionistShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedStaff?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={inhouseUsers?.length > 0 ? inhouseUsers : []}
                    selectedOption={filters?.selectedStaff}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedStaff: selectedValue,
                      })
                    }
                    name="Staff"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isAccountTypeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.accountType ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      from === 'staff-onboarding'
                        ? onboarding_staff_types
                        : from === 'payrole-processor-logs'
                          ? all_account_types.filter(
                              (value) =>
                                value?.value === 'receptionist' || value?.value === 'trainer'
                            )
                          : all_account_types
                    }
                    selectedOption={filters?.accountType}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        accountType: selectedValue,
                      })
                    }
                    name={
                      from === 'docs'
                        ? 'Feature Relevant For'
                        : from === 'staff-onboarding'
                          ? 'Select Employee Type'
                          : from === 'feature-mappings'
                            ? 'Select Role'
                            : 'Role'
                    }
                  />
                </div>
              )}

              {allowedFilters.isOtherUserShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selAddedby ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      from === 'import-members'
                        ? inhouseUsers?.length > 0
                          ? inhouseUsers?.filter((value) =>
                              value?.label?.includes('Sales Executive')
                            )
                          : []
                        : from === 'pt-transfer-history' || from === 'member-checkin-logs'
                          ? inhouseUsers?.length > 0
                            ? inhouseUsers?.filter((value) => value?.label?.includes('admin'))
                            : []
                          : from === 'lead-management' && inhouseUsers?.length > 0
                            ? inhouseUsers?.filter((value) => !value?.label?.includes('trainer'))
                            : inhouseUsers?.length > 0
                              ? inhouseUsers
                              : []
                    }
                    selectedOption={filters?.selAddedby}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selAddedby: selectedValue,
                      })
                    }
                    name={
                      from === 'df'
                        ? 'Select Created By'
                        : from === 'import-members' ||
                            (from === 'expense-management' && clickedCard === 0)
                          ? 'Requested By'
                          : from === 'feature-mappings'
                            ? 'Select User'
                            : from === 'pt-transfer-history'
                              ? 'transferred by'
                              : from === 'docs'
                                ? 'Select Stakeholder'
                                : from === 'cash-reports'
                                  ? 'Created By'
                                  : from === 'membership-transfer'
                                    ? 'Transferred By'
                                    : from === 'sales-value' ||
                                        from === 'home-global' ||
                                        from === 'agent-daily-target' ||
                                        (from === 'expense-management' &&
                                          (clickedCard === 1 ||
                                            clickedCard === 2 ||
                                            clickedCard === 3))
                                      ? 'Cluster Manager'
                                      : from === 'live-pt-trial-notifications' ||
                                          from === 'live-bca-logs-notifications' ||
                                          from === 'member-checkin-logs' ||
                                          from === 'renewal-reminder'
                                        ? 'resolved by'
                                        : from === 'hygiene-taks-tabwise'
                                          ? 'Approved/Rejected By'
                                          : 'Added By'
                    }
                  />
                </div>
              )}

              {allowedFilters.isApprovalManagerShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedApprovalManager ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      from === 'trainer-member-engagement' ||
                      from === 'import-members' ||
                      clickedCard === 'discount-payments'
                        ? inhouseUsers?.length > 0
                          ? inhouseUsers?.filter((value) => value?.label?.includes('admin'))
                          : []
                        : processManagers?.length > 0
                          ? processManagers
                          : []
                    }
                    selectedOption={filters?.selectedApprovalManager}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedApprovalManager: selectedValue,
                      })
                    }
                    name={
                      from === 'trainer-member-engagement'
                        ? 'Engagement Request Approve/Reject By'
                        : from === 'import-members'
                          ? 'Approved/Rejected By'
                          : clickedCard === 'discount-payments'
                            ? 'Select Approved/Rejected By'
                            : 'Approval Manager'
                    }
                  />
                </div>
              )}

              {allowedFilters.isApprovalStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedApprovalStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      from === 'couple-membership-request' ||
                      (from === 'membership-transfer' && selectedTab === 1) ||
                      from === 'subscription-extension'
                        ? approve_reject_pending
                        : from === 'gym-feedbacks'
                          ? resolve_status
                          : from === 'membership-transfer' && selectedTab === 0
                            ? dfPaymentStatus
                            : approval_require
                    }
                    selectedOption={filters?.selectedApprovalStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedApprovalStatus: selectedValue,
                      })
                    }
                    name={
                      from === 'couple-membership-request' ||
                      (from === 'membership-transfer' && selectedTab === 1) ||
                      from === 'subscription-extension'
                        ? 'Approval Status'
                        : from === 'gym-feedbacks'
                          ? 'Reslove Status'
                          : from === 'membership-transfer' && selectedTab === 0
                            ? 'Payment Status'
                            : 'Engagement Approval Require'
                    }
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isIsApprovedStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedIsApproved?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={
                      clickedCard === 'discount-payments'
                        ? discount_payments_approval_status
                        : leaveStatus
                    }
                    selectedOption={filters?.selectedIsApproved}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedIsApproved: selectedValue,
                      })
                    }
                    name={
                      clickedCard === 'discount-payments'
                        ? 'Select Approval Status'
                        : 'Engagement Approval Status'
                    }
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isAPaidByShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedPaidBy ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={expenseAccountants?.length > 0 ? expenseAccountants : []}
                    selectedOption={filters?.selectedPaidBy}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedPaidBy: selectedValue,
                      })
                    }
                    name={'Paid By'}
                  />
                </div>
              )}

              {allowedFilters.isShiftTypeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedShiftType && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={shift_types}
                    selectedOption={filters?.selectedShiftType}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedShiftType: selectedValue,
                      })
                    }
                    name="Shift Type"
                  />
                </div>
              )}

              {allowedFilters.isShiftTimeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedShiftTime && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={shift_timings}
                    selectedOption={filters?.selectedShiftTime}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedShiftTime: selectedValue,
                      })
                    }
                    name="Shift Time"
                  />
                </div>
              )}

              {allowedFilters.isFDShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedFd && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdown
                    options={inhouseUsers?.length > 0 ? inhouseUsers : []}
                    selectedOption={filters?.selectedFd}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedFd: selectedValue,
                      })
                    }
                    name="FD"
                  />
                </div>
              )}

              {allowedFilters.isShiftStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedShiftStatus?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={shift_statuses}
                    selectedOption={filters?.selectedShiftStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedShiftStatus: selectedValue,
                      })
                    }
                    name="Shift Status"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isHalfDayCheckinShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedHalfDayCheckinStatus?.value && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={halfday_late_checkin_statuses}
                    selectedOption={filters?.selectedHalfDayCheckinStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedHalfDayCheckinStatus: selectedValue,
                      })
                    }
                    name="Checkin Status"
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isUTMCampaignShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selUTMCampaign ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={utmParams?.utm_campaign?.length > 0 ? utmParams.utm_campaign : []}
                    selectedOption={filters?.selUTMCampaign}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selUTMCampaign: selectedValue,
                      })
                    }
                    name="UTM Campaign"
                  />
                </div>
              )}

              {allowedFilters.isUTMMediumShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selUTMMedium && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={utmParams?.utm_medium?.length > 0 ? utmParams.utm_medium : []}
                    selectedOption={filters?.selUTMMedium}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selUTMMedium: selectedValue,
                      })
                    }
                    name="UTM Medium"
                  />
                </div>
              )}

              {allowedFilters.isUTMContentShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selUTMContent && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={utmParams?.utm_content?.length > 0 ? utmParams.utm_content : []}
                    selectedOption={filters?.selUTMContent}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selUTMContent: selectedValue,
                      })
                    }
                    name="UTM Content"
                  />
                </div>
              )}

              {allowedFilters.isUTMTermShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selUTMTerm && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={utmParams?.utm_term?.length > 0 ? utmParams.utm_term : []}
                    selectedOption={filters?.selUTMTerm}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selUTMTerm: selectedValue,
                      })
                    }
                    name="UTM Term"
                  />
                </div>
              )}

              {allowedFilters.isAssignedLeadDayShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selAssignedLeadDay && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={days_upto_30}
                    selectedOption={filters?.selAssignedLeadDay}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selAssignedLeadDay: selectedValue,
                      })
                    }
                    name={
                      from === 'one-day-membership' || from === 'recurring-999'
                        ? 'Days (Add To LMS)'
                        : 'Days (Raw Lead To Assign)'
                    }
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isAssignedLeadHourShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selAssignedLeadHour && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={hours_upto_24}
                    selectedOption={filters?.selAssignedLeadHour}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selAssignedLeadHour: selectedValue,
                      })
                    }
                    name={
                      from === 'one-day-membership' || from === 'recurring-999'
                        ? 'Hours (Add To LMS)'
                        : 'Hours (Raw Lead To Assign)'
                    }
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isAssignedLeadMinuteShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selAssignedLeadMinute && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={mins_upto_60}
                    selectedOption={filters?.selAssignedLeadMinute}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selAssignedLeadMinute: selectedValue,
                      })
                    }
                    name={
                      from === 'one-day-membership' || from === 'recurring-999'
                        ? 'Minutes (Add To LMS)'
                        : 'Minutes (Raw Lead To Assign)'
                    }
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isAssignedLeadFollowupDayShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selAssignLeadFollowupDay && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={days_upto_30}
                    selectedOption={filters?.selAssignLeadFollowupDay}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selAssignLeadFollowupDay: selectedValue,
                      })
                    }
                    name={
                      from === 'one-day-membership' || from === 'recurring-999'
                        ? 'Days (First Followup)'
                        : 'Days (Assgined To First Followup)'
                    }
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isAssignedLeadFollowupHourShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selAssignLeadFollowupHour && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={hours_upto_24}
                    selectedOption={filters?.selAssignLeadFollowupHour}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selAssignLeadFollowupHour: selectedValue,
                      })
                    }
                    name={
                      from === 'one-day-membership' || from === 'recurring-999'
                        ? 'Hours (First Followup)'
                        : 'Hours (Assgined To First Followup)'
                    }
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isAssignedLeadFollowupMinuteShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selAssignLeadFolloupMinute && 'redBorderRedText'
                  }`}
                >
                  <SelectDropdownLabel
                    options={mins_upto_60}
                    selectedOption={filters?.selAssignLeadFolloupMinute}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selAssignLeadFolloupMinute: selectedValue,
                      })
                    }
                    name={
                      from === 'one-day-membership' || from === 'recurring-999'
                        ? 'Minutes (First Followup)'
                        : 'Minutes (Assgined To First Followup)'
                    }
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isAddedNotAddedToLeadFilterShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selAddNotAddToLead?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={added_not_added_to_lead_boolean}
                    selectedOption={filters?.selAddNotAddToLead}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selAddNotAddToLead: selectedValue,
                      })
                    }
                    name="LMS Status"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isODMStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedODMStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={from === 'recurring-999' ? recusrring_status : ODM_STATUS}
                    selectedOption={filters?.selectedODMStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedODMStatus: selectedValue,
                      })
                    }
                    name={from === 'recurring-999' ? '999 Plan Status' : 'ODM Status'}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isPlanTypesShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedPlanType?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={planTypes}
                    selectedOption={filters?.selectedPlanType}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedPlanType: selectedValue,
                      })
                    }
                    name="Select Plan Type"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isRegularPlanTypesShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedPlan?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={regularPlansDropdown}
                    selectedOption={filters?.selectedPlan}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedPlan: selectedValue,
                      })
                    }
                    name="Select Plan"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isCheckinDaysAgoShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedCheckinDaysAgo?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={daysAgo}
                    selectedOption={filters?.selectedCheckinDaysAgo}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedCheckinDaysAgo: selectedValue,
                      })
                    }
                    name="Member Last Checkin"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isCheckinTimeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper multiselect-filter multi-select-max-width ${
                    filters?.selectedCheckinTime?.length > 0 ? 'redBorderRedText' : ''
                  }`}
                >
                  <MultiSelect
                    options={timeSlots}
                    state={filters?.selectedCheckinTime}
                    setState={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedCheckinTime: selectedValue,
                      })
                    }
                    name={from === 'hygiene-taks-tabwise' ? 'Task Times' : 'Member Checkin Time'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isWorkoutDaysAgoShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedWorkoutDaysAgo?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={daysAgo}
                    selectedOption={filters?.selectedWorkoutDaysAgo}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedWorkoutDaysAgo: selectedValue,
                      })
                    }
                    name="Last Workout"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isCheckinDaysAgoShow1 && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedCheckinDaysAgo1?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={daysAgo}
                    selectedOption={filters?.selectedCheckinDaysAgo1}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedCheckinDaysAgo1: selectedValue,
                      })
                    }
                    name="Trainer Last Checkin"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isCheckinTimeShow1 && (
                <div
                  className={`commonWrapper dropdownCommonWrapper multiselect-filter multi-select-max-width ${
                    filters?.selectedCheckinTime1?.length > 0 ? 'redBorderRedText' : ''
                  }`}
                >
                  <MultiSelect
                    options={timeSlots}
                    state={filters?.selectedCheckinTime1}
                    setState={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedCheckinTime1: selectedValue,
                      })
                    }
                    name="Trainer Checkin Time"
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isMonthFilterShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedMonth?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={months}
                    selectedOption={filters?.selectedMonth}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedMonth: selectedValue,
                      })
                    }
                    name={from === 'health-tracking' ? 'DOB Month' : 'Select Month'}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isYearFilterShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedYear?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={from === 'health-tracking' ? yearsPast100 : years}
                    selectedOption={filters?.selectedYear}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedYear: selectedValue,
                      })
                    }
                    name={from === 'health-tracking' ? 'DOB Year' : 'Year'}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isDashboardMenuShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedMenu?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={allMenus}
                    selectedOption={filters?.selectedMenu}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedMenu: selectedValue,
                      })
                    }
                    name="Menu"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isDashboardFeatureShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedFeature?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={allFeatures}
                    selectedOption={filters?.selectedFeature}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedFeature: selectedValue,
                      })
                    }
                    name="Feature"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isExpiringInDaysShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selExpiringInDays?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={withinDays}
                    selectedOption={filters?.selExpiringInDays}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selExpiringInDays: selectedValue,
                      })
                    }
                    name={
                      from === 'trainer-member-engagement'
                        ? 'Regular Subs Expiring In'
                        : 'Expiring In'
                    }
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isNotificationStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedNotifyStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={
                      from === 'hygiene-taks-tabwise'
                        ? required_not_required_statuses
                        : notify_statuses
                    }
                    selectedOption={filters?.selectedNotifyStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedNotifyStatus: selectedValue,
                      })
                    }
                    name={from === 'hygiene-taks-tabwise' ? 'Media Required' : 'Notification'}
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isFeatureGroupsShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedFeatureGroup?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={allDropdownData.allFeatureGroups}
                    selectedOption={filters?.selectedFeatureGroup}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedFeatureGroup: selectedValue,
                      })
                    }
                    name="Feature Group"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isCoupleplanFilterShow && (
                <div className="commonWrapperWithLabel">
                  {from === 'subscriptions' && <span className="label">Couple Plan</span>}

                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedCouplePlan?.value ? 'redBorderRedText' : ''
                    }`}
                  >
                    <SelectDropdown
                      options={couple_plan_filter}
                      selectedOption={filters?.selectedCouplePlan}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedCouplePlan: selectedValue,
                        })
                      }
                      name={from === 'centralised-plans' ? 'Couple Plan' : 'Link Type'}
                      isDisable={isLoading}
                      preventKeyboardOpen={true}
                    />
                  </div>
                </div>
              )}

              {allowedFilters.isGenderShow && (
                <div className="commonWrapperWithLabel">
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedGender?.value ? 'redBorderRedText' : ''
                    }`}
                  >
                    <SelectDropdown
                      options={gender}
                      selectedOption={filters?.selectedGender}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedGender: selectedValue,
                        })
                      }
                      name="Gender"
                      isDisable={isLoading}
                      preventKeyboardOpen={true}
                    />
                  </div>
                </div>
              )}

              {allowedFilters.isVisitScheduledShow && (
                <div className="commonWrapperWithLabel">
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selVisitScheduled?.value ? 'redBorderRedText' : ''
                    }`}
                  >
                    <SelectDropdown
                      options={visit_scheduled_options}
                      selectedOption={filters?.selVisitScheduled}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selVisitScheduled: selectedValue,
                        })
                      }
                      name="Visit Scheduled"
                      isDisable={isLoading}
                      preventKeyboardOpen={true}
                    />
                  </div>
                </div>
              )}

              {allowedFilters.isVisitDoneShow && (
                <div className="commonWrapperWithLabel">
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selVisitDone?.value ? 'redBorderRedText' : ''
                    }`}
                  >
                    <SelectDropdown
                      options={visit_done_options}
                      selectedOption={filters?.selVisitDone}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selVisitDone: selectedValue,
                        })
                      }
                      name="Visit Done"
                      isDisable={isLoading}
                      preventKeyboardOpen={true}
                    />
                  </div>
                </div>
              )}

              {allowedFilters.isPaymentModeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedPaymentModes?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={df_payment_modes}
                    selectedOption={filters?.selectedPaymentModes}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedPaymentModes: selectedValue,
                      })
                    }
                    name="Payment Mode"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isExpenseCategoryShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedExpenseCategory?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={allExpenseCategories || []}
                    selectedOption={filters?.selectedExpenseCategory}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedExpenseCategory: selectedValue,
                      })
                    }
                    name="Expense Category"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isWapImageShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedWhatsappVerification?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={[
                      {
                        label: 'Whatsapp Message Done',
                        value: '1',
                      },
                      {
                        label: 'Whatsapp Message Not Done',
                        value: '0',
                      },
                    ]}
                    selectedOption={filters?.selectedWhatsappVerification}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedWhatsappVerification: selectedValue,
                      })
                    }
                    name="Whatsapp Verification"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isPlanDurationShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedPlanDuration?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={regularPlansDropdown}
                    selectedOption={filters?.selectedPlanDuration}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedPlanDuration: selectedValue,
                      })
                    }
                    name="Plan Duration"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isAllAccessPlanShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedAllAccessPlan?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={all_access_plan}
                    selectedOption={filters?.selectedAllAccessPlan}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedAllAccessPlan: selectedValue,
                      })
                    }
                    name="All Access Plan"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isGymCategoryShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedGymCategory?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={allGymCategories}
                    selectedOption={filters?.selectedGymCategory}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedGymCategory: selectedValue,
                      })
                    }
                    name="Gym Category"
                    isDisable={isLoading || centralisedPlanCategoriesLoading}
                  />
                </div>
              )}

              {allowedFilters.isTemplateCategoryShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedTemplateCategory?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={template_categories}
                    selectedOption={filters?.selectedTemplateCategory}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedTemplateCategory: selectedValue,
                      })
                    }
                    name="Template Category"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isVariableTypeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedVariableType?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={variable_types}
                    selectedOption={filters?.selectedVariableType}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedVariableType: selectedValue,
                      })
                    }
                    name="Variable Type"
                    isDisable={isLoading}
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isVariableValueShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedVariableValue?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={broadcast_variable}
                    selectedOption={filters?.selectedVariableValue}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedVariableValue: selectedValue,
                      })
                    }
                    name="Variable Value"
                    isDisable={isLoading}
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isEmailTemplateShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedEmailTemplate?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={allDropdownData.allEmailTemplates}
                    selectedOption={filters?.selectedEmailTemplate}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedEmailTemplate: selectedValue,
                      })
                    }
                    name="Email Template"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isEmailTemplateShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedWPTemplate?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={allDropdownData.allWPTemplates}
                    selectedOption={filters?.selectedWPTemplate}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedWPTemplate: selectedValue,
                      })
                    }
                    name="Whatsapp Template"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isBroadcastChannelShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedBroadcastChannel?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={broadcast_channel}
                    selectedOption={filters?.selectedBroadcastChannel}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedBroadcastChannel: selectedValue,
                      })
                    }
                    name="Broadcast Channel"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isExperienceLevelShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedExperienceLevel?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={experience_level}
                    selectedOption={filters?.selectedExperienceLevel}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedExperienceLevel: selectedValue,
                      })
                    }
                    name="Member Experience Level"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isPaymentLocationShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedPaymentLocation?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={payment_location}
                    selectedOption={filters?.selectedPaymentLocation}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedPaymentLocation: selectedValue,
                      })
                    }
                    name="Payment Location"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isSubmissionTypeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedSubmissionType?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={submission_type}
                    selectedOption={filters?.selectedSubmissionType}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedSubmissionType: selectedValue,
                      })
                    }
                    name="Submission Type"
                    isDisable={isLoading}
                    preventKeyboardOpen={true}
                  />
                </div>
              )}

              {allowedFilters.isTrainerStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedTrainerStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdown
                    options={active_deleted}
                    selectedOption={filters?.selectedTrainerStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedTrainerStatus: selectedValue,
                      })
                    }
                    name={'Trainer Status'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isRegularPlanStatusShow && (
                <div className="commonWrapperWithLabel">
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedRegularPlanStatus?.value ? 'redBorderRedText' : ''
                    }`}
                  >
                    <SelectDropdownLabel
                      options={susbscriptionStatus}
                      selectedOption={filters?.selectedRegularPlanStatus}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedRegularPlanStatus: selectedValue,
                        })
                      }
                      name="Regular Plan Status"
                      isDisable={isLoading}
                    />
                  </div>
                </div>
              )}

              {allowedFilters.isPTPlanStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedPTPlanStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={pt_plan_status}
                    selectedOption={filters?.selectedPTPlanStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedPTPlanStatus: selectedValue,
                      })
                    }
                    name="PT Plan Status"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isWPTemplateShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedWPTemplate?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={allDropdownData.allWPTemplates}
                    selectedOption={filters?.selectedWPTemplate}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedWPTemplate: selectedValue,
                      })
                    }
                    name="Whatsapp Template"
                    isDisable={isLoading || broadcastWPTemplatesLoading}
                  />
                </div>
              )}

              {allowedFilters.isBCASchedulerConditionShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedBCASchedulerCondition?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={bca_scheduler_condition}
                    selectedOption={filters?.selectedBCASchedulerCondition}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedBCASchedulerCondition: selectedValue,
                      })
                    }
                    name="Condition"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isScheduleTypeShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedScheduleType?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={scheduler_types}
                    selectedOption={filters?.selectedScheduleType}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedScheduleType: selectedValue,
                      })
                    }
                    name="Schedule Type"
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isUserApprovalStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedUserApprovalStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={approve_reject_pending}
                    selectedOption={filters?.selectedUserApprovalStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedUserApprovalStatus: selectedValue,
                      })
                    }
                    name={'Staff Review'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />

                  {allowedFilters.isWorkoutGoalsShow && (
                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedWorkoutGoal?.value ? 'redBorderRedText' : ''
                      }`}
                    >
                      <SelectDropdownLabel
                        options={workoutGoals?.length > 0 ? workoutGoals : memberGoals}
                        selectedOption={filters?.selectedWorkoutGoal}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedWorkoutGoal: selectedValue,
                          })
                        }
                        name="Workout Goal"
                        isDisable={isLoading}
                      />
                    </div>
                  )}
                </div>
              )}

              {allowedFilters.isStakeholderApprovalStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedStakeholderApprovalStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={approve_reject_pending}
                    selectedOption={filters?.selectedStakeholderApprovalStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedStakeholderApprovalStatus: selectedValue,
                      })
                    }
                    name={from === 'payrole-processor-logs' ? 'HR Approval' : 'Approval Status'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isEmailStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedEmailStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={email_statuses}
                    selectedOption={filters?.selectedEmailStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedEmailStatus: selectedValue,
                      })
                    }
                    name={'Email'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isRoasterStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedRoasterStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={roaster_status}
                    selectedOption={filters?.selectedRoasterStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedRoasterStatus: selectedValue,
                      })
                    }
                    name={'Roaster Status'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isWeekoffStatusShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedWeekoffStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={weekoff_status}
                    selectedOption={filters?.selectedWeekoffStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedWeekoffStatus: selectedValue,
                      })
                    }
                    name={'Week Off Status'}
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isRenewalShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedRenewalStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={fresh_existing}
                    selectedOption={filters?.selectedRenewalStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedRenewalStatus: selectedValue,
                      })
                    }
                    name="Member Type"
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isStuckShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedStuckStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={stuck_status}
                    selectedOption={filters?.selectedStuckStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedStuckStatus: selectedValue,
                      })
                    }
                    name="PT Trial Status"
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isThreeDayTrialShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedThreeDayTrialStatus?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={three_day_pt_trial_session_status}
                    selectedOption={filters?.selectedThreeDayTrialStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedThreeDayTrialStatus: selectedValue,
                      })
                    }
                    name="PT Trial Progress"
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isWapSentShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedWapSent?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={wap_sent_status}
                    selectedOption={filters?.selectedWapSent}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedWapSent: selectedValue,
                      })
                    }
                    name="Message Sent"
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isWapDeliveredShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedWapDelivered?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={wap_delivered_status}
                    selectedOption={filters?.selectedWapDelivered}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedWapDelivered: selectedValue,
                      })
                    }
                    name="Message Delivered"
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isWapReadShow && (
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedWapRead?.value ? 'redBorderRedText' : ''
                  }`}
                >
                  <SelectDropdownLabel
                    options={wap_read_status}
                    selectedOption={filters?.selectedWapRead}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedWapRead: selectedValue,
                      })
                    }
                    name="Message Read"
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>
              )}

              {allowedFilters.isSearchShow ? (
                <div className="filter-searchbar-container span2">
                  <div
                    className={`inputCommonWrapper flexSpacebetween searchBarContainer ${
                      searchFilterApplied ? 'redBorderRedText' : ''
                    } ${isLoading ? 'disabled' : ''}`}
                  >
                    <input
                      type="search"
                      name="searchString"
                      className="input"
                      placeholder={
                        from === 'hygine-tasks-approval'
                          ? 'search by task name'
                          : searchPlaceHolder
                            ? searchPlaceHolder
                            : 'Search...'
                      }
                      value={filters?.searchString}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          searchString: e.target.value,
                        })
                      }
                      disabled={isLoading}
                      style={{ textTransform: 'initial' }}
                    />
                    <button
                      type="button"
                      className="button"
                      onClick={onClickSearch}
                      disabled={isLoading}
                    >
                      search
                      <BiSearchIcon />
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default CmnFilters;
